import "../scss/bundle.scss";
// import barba from '@barba/core'
// import barbaPrefetch from '@barba/prefetch'
import LocomotiveScroll from 'locomotive-scroll'
import { gsap } from "gsap"
import axios from 'axios';
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)
import SimpleBar from 'simplebar'
import Swiper from 'swiper'

import LazyLoad from 'vanilla-lazyload'

import {detectedDevice} from 'detected-device'




let $ = jQuery

let doc = document.documentElement
let hh = window.innerHeight
let ww = window.innerWidth
let body = document.body
let mousePos = { x: ww / 2, y: hh / 2 }
var scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
let awdScroll
let animations
let classHeader
let classFilters
let classCategorieMobile
let classMinicart
let classBtnListaTaglie
let DropdownElements
let globalSearchForm
let globalIsAnimating

let language = document.getElementById('language').getAttribute('data-language')

let homeUrl = document.getElementById('homeUrl').value
// console.log(homeUrl)

let colorBlack = '#000'
let colorWhite = '#fff'
let colorError = '#c42323'
let colorSuccess = '#188a18'

// console.log('test')

const validateEmail = (email) => {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function calcWinsize() {
    return { width: window.innerWidth, height: window.innerHeight }
}
let winsize = calcWinsize()


let ratio = window.devicePixelRatio || 1
let screen = {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio
}
// alert(screen.width)


function createYouTubeIFrame(){
    var tag = document.createElement('script');
    tag.setAttribute("id", "youtube-video-script")
    tag.src = "https://www.youtube.com/iframe_api"
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)


    var player;
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('player', {
        height: '360',
        width: '640',
        videoId: 'fiLMn8MKJRs',
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
    }

    let iframeFakeControl = document.querySelector('.row .iframe-fake-control')
    function onPlayerReady(event) {
        iframeFakeControl.addEventListener('click', () => {
            if (event.data == YT.PlayerState.PLAYING) {
                event.target.stopVideo();
            }
            else{
                event.target.playVideo();
            }
        })


      }


      function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING) {
            iframeFakeControl.addEventListener('click', () => {
                event.target.stopVideo();
            })
        }
        else{
            iframeFakeControl.addEventListener('click', () => {
                event.target.playVideo();
            })
        }
      }

    setTimeout( () => {
        onYouTubeIframeAPIReady()
    },2000)

}


let isMobile = detectedDevice.isMobile()

// alert(isMobile)

// const _isMobile = () => {
//     if (
//         (winsize.width <= 767)
//     ) {
//         return 'portrait';
//     }
//     else if (
//         (winsize.width > 428 && winsize.height < 500)
//     ) {
//         return 'landscape'
//     }
//     else {
//         return false;
//     }
// }
// let isMobile = _isMobile()

// const _isIpad = () => {
//     if (
//         (screen.width === 1536 && winsize.width === 768) //* iPad Portrait reale e ispezionatore
//     ) {
//         return 'portrait'

//     }
//     else if (
//         (screen.width === 1536 && winsize.width === 1024) || //* iPad Landscape reale
//         (screen.width === 2048 && screen.height === 1536) //!iPad Landscape ispezionatore
//     ) {
//         return 'landscape'
//     }
//     else {
//         return false;
//     }
// }
// let isTablet = _isIpad()
let isTablet = detectedDevice.isTablet()

// const _isIpadPro = () => {
//     if (
//         (screen.width === 2048 && winsize.width === 1024 && winsize.height > 768) //* iPadPro Portrait reale e ispezionatore
//     ) {
//         return 'portrait'
//     }
//     else if (
//         (screen.width === 2048 && winsize.width === 1366) ||  //* iPadPro Landscape reale
//         (screen.width === 2732 && winsize.width === 1366)     //! iPadPro Landscape ispezionatore
//     ) {
//         return 'landscape'
//     }
//     else {
//         return false
//     }
// }
// let isIpadPro = _isIpadPro()
let isIpadPro = detectedDevice.isIpadPro()

// const _isAllTablet = () => {
//     if (isTablet || isIpadPro) {
//         return true
//     }
//     else {
//         return false
//     }

// }
// let isAllTablet = _isAllTablet()
let isAllTablet = detectedDevice.isAllTablet()
// alert(isAllTablet)

// const _isAllMobileDevices = () => {
//     if (isMobile || isAllTablet) {
//         return true;
//     }
//     else {
//         return false;
//     }
// }
// let isAllMobileDevices = _isAllMobileDevices()
let isAllMobileDevices = detectedDevice.isAllMobileDevices()
window.addEventListener('resize', () => {
    winsize = calcWinsize()

    // isMobile = _isMobile()
    isMobile = detectedDevice.isMobile()
    // isTablet = _isIpad()
    isTablet = detectedDevice.isTablet()
    // isIpadPro = _isIpadPro()
    isIpadPro = detectedDevice.isIpadPro()
    // isAllTablet = _isAllTablet()
    isAllTablet = detectedDevice.isAllTablet()
    // isAllMobileDevices = _isAllMobileDevices()
    isAllMobileDevices = detectedDevice.isAllMobileDevices()
})

function reloadPageOnOrientationChange(){
    window.addEventListener('orientationchange', () => {
        // window.location.reload()
    })
}

//!test
window.addEventListener('orientationchange', () => {
    // console.log('orientation change, is mobile : ', isMobile)
    // alert(winsize.width)
    // window.location.reload()
})
// window.addEventListener('resize', () => {
//     console.log('window resize, is mobile: ', isMobile)
// })

const getMousePos = (ev) => {
    let posx = 0;
    let posy = 0;
    if (!ev) ev = window.event;
    if (ev.pageX || ev.pageY) {
        posx = ev.pageX;
        posy = ev.pageY;
    }
    else if (ev.clientX || ev.clientY) {
        posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
        posy = ev.clientY + body.scrollTop + docEl.scrollTop;
    }
    return { x: posx, y: posy };

}
window.addEventListener('mousemove', e => {
    mousePos = getMousePos(e);
})

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function clickHamburger() {
    let isAnimating = false
    let hamburgerHitArea = document.querySelector('.hamburger')

    hamburgerHitArea.addEventListener('click', () => {
        //apro menu
        if (!hamburgerHitArea.classList.contains('opened')) {
            if (isAnimating) return
            isAnimating = true
            body.classList.add('header-bloccato')
            if (document.querySelector('.header-cerca') !== null && document.querySelector('.header-cerca').classList.contains('opened')) {
                if (globalSearchForm.isOpening) return
                globalSearchForm.isOpening = true
                globalSearchForm.closeSearchPage()
                openMenu()
                    .then(() => {
                        // initMenuSimplebar()
                        isAnimating = false
                })

            }
            else {
                openMenu()
                    .then(() => {
                        // initMenuSimplebar()
                        isAnimating = false
                    })
            }
            hamburgerHitArea.classList.add('opened')
        }
        //chiudo menu
        else {
            if (isAnimating) return
            isAnimating = true
            body.classList.remove('header-bloccato')
            if(document.querySelector('.submenu-mobile.opened') != null){
                let qualeSubmenu = document.querySelector('.submenu-mobile.opened').getAttribute('data-submenu-mobile')
                closeSubmenuMobile(qualeSubmenu)
            }
            closeMenu()
            .then( () => {
                isAnimating = false
            })
            hamburgerHitArea.classList.remove('opened')
        }

    })
}

function initMenuSimplebar(){
    if(document.querySelector('.menu__inner') !== null){
        let menuInner = document.querySelector('.menu__inner')
        if(menuInner.classList.contains('simplebar-initialized')) return
        menuInner.classList.add('simplebar-initialized')
        new SimpleBar(menuInner, { autoHide: true });
    }
}

function openMenu() {
    let menuContainer = document.querySelector('.menu__container')
    menuContainer.classList.add('opened')
    menuContainer.style.display = 'block'
    return new Promise((resolve, reject) => {
        openHamburger();
        gsap.timeline({ onComplete: resolve })
            .add(() => {
                // if(){
                classHeader.toAlternativeColor();
                // }
            })
            .to(menuContainer, {
                duration: 0.6,
                autoAlpha: 1
            })
    })
}


function openSubmenuMobile(qualeSubmenu){
    return new Promise( resolve => {
        let submenu = document.querySelector(`.submenu-mobile[data-submenu-mobile="${qualeSubmenu}"]`)
        let submenuShadow = submenu.querySelector('.submenu__shadow span')
        let submenuWrapper = submenu.querySelector('.submenu__wrapper')
        let submenus = document.querySelectorAll(`.submenu-mobile`)
        submenus.forEach(sm => {
            sm.classList.remove('opened')
        })
        submenu.classList.add('opened')
        gsap.set(submenu, {
            x: '0%'
        })
        gsap.to(submenuShadow,{
            duration: 0.4,
            autoAlpha: 1
        })
        gsap.to(submenuWrapper,{
            duration: 0.8,
            x: '0%',
            ease: 'power1.inOut',
            delay: 0.2,
            onComplete: () => {
                resolve()                
            }
        })
    })
}
function closeSubmenuMobile(qualeSubmenu){
    return new Promise( resolve => {
        let submenu = document.querySelector(`.submenu-mobile[data-submenu-mobile="${qualeSubmenu}"]`)
        let submenuShadow = submenu.querySelector('.submenu__shadow span')
        let submenuWrapper = submenu.querySelector('.submenu__wrapper')

        gsap.to(submenuWrapper,{
            duration: 0.4,
            x: '100%',
            ease: 'power1.inOut'
        })
        gsap.to(submenuShadow,{
            duration: 0.2,
            autoAlpha: 0,
            delay: 0.1,
            onComplete: () => {
                gsap.set(submenu, {
                    x: '100%'
                })           
                submenu.classList.remove('opened')
                resolve()
            }
        })
    })
}

const keyPress = e => {
    if(e.key === 'Escape' || e.keyCode === 27){
        if(document.querySelector('.submenu-mobile.opened') != null){
            let qualeSubmenu = document.querySelector('.submenu-mobile.opened').getAttribute('data-submenu-mobile')
            closeSubmenuMobile(qualeSubmenu)
        }
        closeMenu()
    }
}

window.addEventListener('keyup', e =>{
    keyPress(e)
})

function closeMenu() {
    let menuContainer = document.querySelector('.menu__container')
    menuContainer.classList.remove('opened')
    return new Promise((resolve, reject) => {
        closeHamburger()
        gsap.timeline({ onComplete: resolve })
            .add(() => {
                // if(){
                classHeader.toDefaultColor();
                // }
            })
            .to(menuContainer, {
                duration: 0.3,
                autoAlpha: 0,
                onComplete: () => {
                    menuContainer.style.display = 'none'
                }
            })
    })

}



function openHamburger() {
    let duration = 0.3;
    let boundHamburger = document.querySelector('.hamburger__wrapper').getBoundingClientRect();
    let boundSpanCenter = document.querySelector('.hamburger .span__wrapper.center').getBoundingClientRect();
    let spanCenterTop = boundSpanCenter.top - boundHamburger.top;

    gsap.to(document.querySelector('.span__wrapper.top'), {
        duration: duration,
        top: spanCenterTop,
    });
    gsap.to(document.querySelector('.span__wrapper.top'), {
        duration: duration,
        rotation: 30,
        scale: 0.8,
        delay: 0.3
    });
    gsap.to(document.querySelector('.span__wrapper.bottom'), {
        duration: duration,
        bottom: spanCenterTop,
        ease: 'Power4.in'
    });
    gsap.to(document.querySelector('.span__wrapper.bottom'), {
        duration: duration,
        rotation: -30,
        scale: 0.8,
        delay: 0.3
    });
    gsap.to(document.querySelector('.span__wrapper.center'), {
        duration: 0,
        autoAlpha: 0,
        delay: duration
    });

}

function closeHamburger() {
    let duration = 0.3;
    gsap.to(document.querySelector('.span__wrapper.top'), {
        duration: duration,
        scale: 1,
        rotation: 0
    });
    gsap.to(document.querySelector('.span__wrapper.top'), {
        duration: duration,
        top: 0,
        delay: 0.3,
        ease: 'Power4.in'
    });
    gsap.to(document.querySelector('.span__wrapper.bottom'), {
        duration: duration,
        scale: 1,
        rotation: 0
    });
    gsap.to(document.querySelector('.span__wrapper.bottom'), {
        duration: duration,
        bottom: 0,
        ease: 'Power4.in',
        delay: 0.3
    });
    gsap.to(document.querySelector('.span__wrapper.center'), {
        duration: 0,
        autoAlpha: 1,
        delay: duration
    });
}


class MouseCursor {
    constructor() {
        this.cursor = document.getElementById('custom-cursor')
        this.cursorZoom = this.cursor.querySelector('.zoom')
        this.mousePos = mousePos
        this.mouseCursorTriggerElements = document.querySelectorAll('.mousecursor-trigger-element')
        this.initEvents()
    }
    initEvents() {
        window.addEventListener('mousemove', () => {
            this.mousePos = mousePos
            this.move()
        })
        this.mouseCursorTriggerElements.forEach(el => {
            el.addEventListener('mousemove', ev => {
                let mouseCursorClass = el.dataset.mousecursorClass
                if (el.classList.contains('animated')) {
                    this.cursor.classList.remove(mouseCursorClass)
                }
            })
            el.addEventListener('mouseenter', ev => {
                //La thumbnail selezionata nella gallery del single-product non ha il custom-cursor
                if (el.classList.contains('animated')) return
                let mouseCursorClass = el.dataset.mousecursorClass
                this.cursor.classList.add(mouseCursorClass)
            })
            el.addEventListener('mouseleave', ev => {
                let mouseCursorClass = el.dataset.mousecursorClass
                this.cursor.classList.remove(mouseCursorClass)
            })
        })
    }

    move() {
        gsap.to(this.cursorZoom, {
            duration: 0.4,
            left: this.mousePos.x,
            top: this.mousePos.y,
        })
    }
}


class Rail {

    constructor(rail = null) {
        // console.log(rail)
        if (!rail) return
        this.rail = rail
        this.railContainer = rail.querySelector('.rail__container');
        this.railContainerWidth = this.railContainer.getBoundingClientRect().width;
        this.railItems = Array.from(rail.querySelectorAll('.rail__item .rail-element'));
        this.direction = rail.getAttribute('data-direction');
        this.contatore = 0;
        this.tx = 0;
        // this.lastScrollTop = 0;
        // this.timer = null;
        this.SPEED_CONSTANT = 2;
        this.speedTranslation = this.SPEED_CONSTANT;


        this.initEvents()

    }

    initEvents() {
        this.continueScroll()
    }

    continueScroll() {

        if (!this.rail.classList.contains('rail-locked')) {
            this.contatore++
            if (this.direction == 'left') {
                this.tx -= this.speedTranslation;
            }
            else {
                this.tx += this.speedTranslation;
            }
            this.railItems.forEach((span, i) => {
                if (i == 0) {
                    this.spanPosition = span.getBoundingClientRect().x;
                }
                if (this.direction == 'left' && -1 * this.spanPosition >= this.railContainerWidth) {
                    this.tx = 0;
                }
                else if (this.direction == 'right' && this.spanPosition > 0) {
                    this.tx = -1 * this.railContainerWidth;
                }
                gsap.to(span, {
                    duration: 0,
                    x: this.tx
                })
            })
        }

        window.requestAnimationFrame(this.continueScroll.bind(this))

    }
}

class Header {
    constructor(header) {
        this.header = header
		this.headerHeight = this.header.getBoundingClientRect().height;

        // this.headerBg = document.querySelector('.header__bg')
        //Elementi del header
        this.fillItems = this.header.querySelectorAll('.header-fill-js')
        this.strokeItems = this.header.querySelectorAll('.header-stroke-js')
        this.colorItem = this.header.querySelectorAll('.js-header-color')
        this.colorItemReverse = this.header.querySelectorAll('.js-header-color-reverse')
        this.backgroundItem = this.header.querySelectorAll('.js-header-background')

		// if(document.querySelector('.link--with-submenu') !== null){
		// 	this.headerSale = document.querySelector('.header__sale')
		// 	this.linkSale = this.header.querySelector('.link--sale');
		// 	this.linkSaleAnchor = this.linkSale.querySelector('a');
		// 	this.linkSaleHeight = this.linkSale.getBoundingClientRect().height;
		// 	this.linkSalePaddingBottomToSet = (this.headerHeight - this.linkSaleHeight) / 2;

        //     // console.log(this.linkSalePaddingBottomToSet)
		// }

		if(document.querySelector('.link--with-submenu') !== null){
			// this.headerSale = document.querySelector('.header__sale')
			// this.linkSale = this.header.querySelector('.link--sale');
			// this.linkSaleAnchor = this.linkSale.querySelector('a');
			this.linkSaleHeight = document.querySelector('.link--with-submenu').getBoundingClientRect().height;
			this.linkSalePaddingBottomToSet = (this.headerHeight - this.linkSaleHeight) / 2;

            // console.log(this.linkSalePaddingBottomToSet)
		}

        this.initEvents()


    }


    initEvents() {
        // this.getHeight()

		if(document.querySelector('.link--with-submenu') !== null){
            const quantiSubmenu = document.querySelectorAll('.link--with-submenu').length
            document.querySelectorAll('.link--with-submenu').forEach((item, index) => {
                const dataSubmenu = item.getAttribute('data-submenu')
                const headerSale = document.querySelector(`.header__submenu[data-submenu="${dataSubmenu}"]`)
                // console.log(headerSale)
                this.preventDeafultClickOnSale(item)
                item.addEventListener('mouseenter', () => {
                    item.querySelector('a').style.paddingBottom = this.linkSalePaddingBottomToSet*2+'px'
                    if((index+1) == quantiSubmenu){
                        item.querySelector('a').style.paddingRight = this.linkSalePaddingBottomToSet*3+'px'
                    } 
                    headerSale.classList.add('opened')
                    this.toggleHeaderSale(headerSale, 'enter')
                })
                item.addEventListener('mouseleave', () => {
                    headerSale.classList.remove('opened')
                    // item.querySelector('a').style.paddingBottom = '0px'
                    // item.querySelector('a').style.paddingRight = '0px'
                    this.toggleHeaderSale(headerSale, 'leave')
                })
                headerSale.addEventListener('mouseenter', () => {
                    headerSale.classList.add('opened')
                    item.querySelector('a').style.paddingBottom = this.linkSalePaddingBottomToSet*2+'px'                    
                    if((index+1) == quantiSubmenu){
                        item.querySelector('a').style.paddingRight = this.linkSalePaddingBottomToSet*3+'px'
                    }
                    this.toggleHeaderSale(headerSale, 'enter')
                })
                headerSale.addEventListener('mouseleave', () => {
                    headerSale.classList.remove('opened')
                    // item.querySelector('a').style.paddingBottom = '0px'
                    // item.querySelector('a').style.paddingRight = '0px'
                    this.toggleHeaderSale(headerSale, 'leave')
                })
            })
        }
        // if(this.header.querySelector('.link--sale') !== null){
        //     this.preventDeafultClickOnSale();
        //     this.linkSale.addEventListener('mouseenter', () => {
        //         this.linkSaleAnchor.style.paddingBottom = this.linkSalePaddingBottomToSet*2+'px'
        //         this.linkSaleAnchor.style.paddingRight = this.linkSalePaddingBottomToSet*3+'px'
        //         this.headerSale.classList.add('opened')
        //         this.toggleHeaderSale('enter')
        //     })
        //     this.linkSale.addEventListener('mouseleave', () => {
        //         this.headerSale.classList.remove('opened')
        //         this.linkSaleAnchor.style.paddingBottom = '0px'
        //         this.linkSaleAnchor.style.paddingRight = '0px'
        //         this.toggleHeaderSale('leave')
        //     })
        //     this.headerSale.addEventListener('mouseenter', () => {
        //         this.headerSale.classList.add('opened')
        //         this.linkSaleAnchor.style.paddingBottom = this.linkSalePaddingBottomToSet*2+'px'
        //         this.linkSaleAnchor.style.paddingRight = this.linkSalePaddingBottomToSet*3+'px'
        //         this.toggleHeaderSale('enter')
        //     })
        //     this.headerSale.addEventListener('mouseleave', () => {
        //         this.headerSale.classList.remove('opened')
        //         this.linkSaleAnchor.style.paddingBottom = '0px'
        //         this.linkSaleAnchor.style.paddingRight = '0px'
        //         this.toggleHeaderSale('leave')
        //     })
        // }
    }

	preventDeafultClickOnSale(item){
        if(item !== null){
            item.querySelector('a').style.cursor = 'default'
            item.querySelector('a').addEventListener('click', e => {
                e.preventDefault()
                return
            })
        }
		// this.linkSaleAnchor.style.cursor = 'default'
		// this.linkSaleAnchor.addEventListener('click', e => {
		// 	e.preventDefault()
		// 	return
		// })
	}
	toggleHeaderSale(headerSale, direction){
		if(direction === 'enter'){
			TweenMax.to(headerSale,0.7,{
				// duration:0.7,
				y:'0%',
				ease:'power3.inOut'
			})
		}
		else{
			TweenMax.to(headerSale,0.55,{
				// duration:0.55,
				y:'-105%',
				ease:'power2.in'
			})
		}
	}

    toAlternativeColor() {
        // gsap.to(this.headerBg,{
        //     duration:0.6,
        // 	backgroundColor:colorBlack
        // })
        gsap.to(this.colorItem, {
            duration: 0.3,
            color: colorWhite
        })
        gsap.to(this.colorItemReverse, {
            duration: 0.3,
            color: colorBlack
        })
        gsap.to(this.backgroundItem, {
            duration: 0.3,
            backgroundColor: colorWhite
        })
        gsap.to(this.strokeItems, {
            duration: 0.3,
            stroke: colorWhite
        })
        gsap.to(this.fillItems, {
            duration: 0.3,
            fill: colorWhite
        })
    }

    toDefaultColor() {

        // gsap.to(this.headerBg,{
        //     duration:0.6,
        // 	backgroundColor:colorWhite
        // })
        gsap.to(this.colorItem, {
            duration: 0.3,
            color: colorBlack
        })
        gsap.to(this.colorItemReverse, {
            duration: 0.3,
            color: colorWhite
        })
        gsap.to(this.backgroundItem, {
            duration: 0.3,
            backgroundColor: colorBlack
        })
        gsap.to(this.strokeItems, {
            duration: 0.3,
            stroke: colorBlack
        })
        gsap.to(this.fillItems, {
            duration: 0.3,
            fill: colorBlack
        })
    }

    getHeight() {
        return this.header.getBoundingClientRect().height
    }
}

class SearchForm {
    constructor(form) {
        this.form = form
        this.input = this.form.querySelector('input')
        this.container = this.form.closest('.search-form')
        this.content = this.form.closest('.search-form').querySelector('.content')
        this.contentOffset = this.content.getBoundingClientRect().top
        this.contentWrapper = this.content.querySelector('.content__wrapper')
        this.formBorder = this.form.querySelector('.form__border')
        this.formBorderSpan = this.formBorder.querySelectorAll('.form__border__span span')
        this.cleanButton = this.form.querySelector('.clean-button')
        this.searchLoader = this.form.querySelector('.search-loader')

        this.header = document.querySelector('header')
        this.links = [...this.header.querySelectorAll('.link')]
        this.links.forEach((link, index) => {
            if (index == 0) {
                let anchor = link.querySelector('a')
                this.originalColor = getComputedStyle(anchor).color
            }

        })

        this.timeout = null

        this.iconaSearch = document.querySelector('.header-cerca')
        this.searchPage = document.querySelector('.search-page')
        this.closeSearch = this.searchPage.querySelector('.close-search-form')

        this.body = document.querySelector('body')

        this.ctaTxt = 'Vedi'
        this.txtNoResults = 'La ricerca non ha prodotto alcun risultato'
        this.txtAddToCart = 'Aggiungi al carrello'
        this.txtDiscover = 'Discover'
        if (language !== 'it') {
            this.ctaTxt = 'View'
            this.txtNoResults = 'Your search produced no results.'
            this.txtAddToCart = 'Add to cart'
        }

        this.isOpening = false

        this.setDomSizes()
        this.initEvents()
    }

    initEvents() {
        this.form.addEventListener('submit', e => {
            e.preventDefault()
        })

        this.iconaSearch.addEventListener('click', () => {
            if (this.isOpening) return
            this.isOpening = true
            if (this.iconaSearch.classList.contains('opened')) {
                this.closeSearchPage()
            }
            else {
                if (document.querySelector('.hamburger') !== null && document.querySelector('.hamburger').classList.contains('opened')) {
                    closeMenu().then(() => {
                        this.openSearchPage()
                        document.querySelector('.hamburger').classList.remove('opened')
                    })
                }
                else {
                    this.openSearchPage()
                }

            }
        })
        this.closeSearch.addEventListener('click', () => {
            this.closeSearchPage()
        })

        this.cleanButton.addEventListener('click', () => {
            this.cleanSearch()
        })


        this.input.addEventListener('keyup', () => {
            this.string = this.input.value
            if (this.string.length > 1) {
                clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                    this.searchAjax()
                    gsap.to(this.cleanButton, {
                        duration: 0.6,
                        autoAlpha: 1
                    })
                }, 200)
            }
            else {
                gsap.to(this.cleanButton, {
                    duration: 0.6,
                    autoAlpha: 1
                })
            }

            // return this.string
            // console.log(this.string)
        })
    }


    setDomSizes() {
        gsap.to(this.content, {
            duration: 0,
            height: winsize.height - this.contentOffset - 80
        })
    }

    openSearchPage() {
        this.searchPage.style.display = 'block';
        this.body.style.overflow = 'hidden';
        this.iconaSearch.classList.add('opened');
        this.input.focus();
        setTimeout(() => {
            this.input.focus();
        }, 200)

        gsap.to(this.formBorderSpan, {
            duration: 0.6,
            width: '100%',
            ease: 'power2.inOut'
        });
        gsap.to(this.searchPage, {
            duration: 0.6,
            autoAlpha: 1,
            onComplete: () => {
                this.isOpening = false;

            }
        });
    }

    closeSearchPage() {
        this.iconaSearch.classList.remove('opened');
        gsap.to(this.formBorderSpan, {
            duration: 0.6,
            width: '0%',
            ease: 'power2.inOut'
        });
        gsap.to(this.searchPage, {
            duration: 0.6,
            autoAlpha: 0,
            onComplete: () => {
                this.isOpening = false;
                this.body.style.overflow = 'visible';
                this.searchPage.style.display = 'none';
                this.cleanSearch();
            }
        })
    }

    cleanSearch() {
        this.input.value = '';
        this.contentWrapper.innerHTML = '';
        this.input.focus();
        gsap.to(this.cleanButton, {
            duration: 0.3,
            autoAlpha: 0
        })
    }

    searchAjax() {
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/search.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                //Nessun risultato
                if (request.response === 'none') {
                    this.contentWrapper.innerHTML = '<p class="verde no-result">' + this.txtNoResults + '</p>';

                }
                //Qualche risultato
                else {
                    let resultObj = JSON.parse(request.response);
                    let item = '';
                    let contatore = 0;
                    let position = '';
                    resultObj.forEach(obj => {
                        contatore++;
                        if ((contatore % 2) == 0) {
                            position = 'right'
                        }
                        else {
                            position = 'left';
                        }
                        if ((contatore % 2) !== 0) {
                            item += '<div class="row-float clearfix">';
                        }
                        item += '<div class="link ' + obj.type + ' ' + position + ' cta-trigger reverse">';
                            item += '<a href="' + obj.url + '">';
                                item += '<div class="link__wrapper">';
                                    item += '<div class="link__img">';
                                        item += '<div class="img">';
                                            item += '<img src="' + obj.image + '">';
                                        item += '</div>';
                                    item += '</div>';
                                    item += '<div class="link__title">';
                                        item += '<h3>' + obj.title + '</h3>';
                                    item += '</div>';
                                    // item += '<div class="link__category">';
                                    //     item += '<span class="uppercase">' + obj.categoryName + '</span>';
                                    // item += '</div>';
                                    item += '<div class="product__cta">';
                                        item += '<div class="cta-stroke-white">';
                                            item += '<div class="cta__bg"></div>';
                                            item += '<div class="cta__border"></div>';
                                            item += '<div class="cta__wrapper">';
                                                item += '<div class="cta__txt">';
                                                    item += '<span class="uppercase">' + this.txtDiscover + '</span>';
                                                item += '</div>';
                                            item += '</div>';
                                        item += '</div>';
                                    item += '</div>';
                                    item += '<div class="link__border">';
                                        item += '<span></span>';
                                    item += '</div>';
                                item += '</div>';
                            item += '</a>';
                        item += '</div>';

                        if ((contatore % 2) == 0 || (obj.totale % 2 !== 0 && contatore == obj.totale)) {
                            item += '</div>';
                        }

                    })

                    this.contentWrapper.innerHTML = item;
                    new SimpleBar(this.content, { autoHide: true });

                }
            }
        }
        request.send(formData)

    }
}


class Negozio {
    constructor(negozio) {
        this.negozio = negozio
        this.negozioWrapperTitle = this.negozio.querySelector('.negozio__titolo')
        this.negozioTitle = this.negozio.querySelector('.titolo')
        this.negozioBg = this.negozio.querySelector('.bg-negozio')

        this.negozioContainer = this.negozio.querySelector('.negozio__container')
        this.negozioHeight = this.negozio.querySelector('.negozio__content').getBoundingClientRect().height

        this.plus = this.negozio.querySelector('.icon .plus')
        this.plusSvg = this.plus.querySelector('.svg-plus')

        this.negozi = [...document.querySelectorAll('.negozio')]

        this.colorBlack = '#000000'
        this.colorWhite = '#ffffff'

        this.initEvents()
    }

    initEvents() {
        this.negozio.addEventListener('mouseover', () => {
            this.hoverNegozio()
        })
        this.negozio.addEventListener('mouseleave', () => {
            this.leaveNegozio()
        })
        this.negozioWrapperTitle.addEventListener('click', () => {
            if (globalIsAnimating) return
            globalIsAnimating = true
            this.calculateNegozioHeight()
            if (this.negozio.classList.contains('open')) {
                this.closeNegozio();
            }
            else {
                this.openNegozio();
            }
        })
        this.recalculateOnDeviceRotation()
    }

    calculateNegozioHeight() {
        this.negozioHeight = this.negozio.querySelector('.negozio__content').getBoundingClientRect().height
    }

    openNegozio() {
        this.negozio.classList.add('current')
        this.paint()
        let headerHeight = document.querySelector('header').getBoundingClientRect().height
        gsap.to(this.negozioContainer, {
            duration: 0.4,
            height: this.negozioHeight,
            ease: 'Power2.inOut',
            onComplete: () => {
                this.negozio.classList.remove('current');
                globalIsAnimating = false;
                awdScroll.update()
                if(isMobile == 'portrait'){
                    console.log('portrait')
                    let container = document.querySelector('#container')
                    gsap.to(container, {
                        duration:0.5,
                        ease:'power2.inOut',
                        scrollTo: {
                            y:this.negozioWrapperTitle,
                            offsetY:headerHeight
                        }

                    })
                }
                else{
                    awdScroll.scrollTo(this.negozioWrapperTitle, {
                        offset: -headerHeight,
                        // offset:500,
                        duration: 500,
                        easeing: [1, 0, 0, 1]
                    });

                }

            }
        });
        gsap.to(this.plus, {
            duration: 0.4,
            rotation: 45,
            ease: 'power1.inOut'
        })
        this.negozio.classList.add('open');
        this.closeAltriNegozi();
    }

    closeNegozio() {
        if (this.negozio.classList.contains('open')) {
            this.clean()
            gsap.to(this.negozioContainer, {
                duration: 0.3,
                height: 0,
                onComplete: () => {
                    globalIsAnimating = false;
                    awdScroll.update()
                }
            });

            gsap.to(this.plus, {
                duration: 0.4,
                rotation: 0,
                ease: 'power1.inOut'
            })
            this.negozio.classList.remove('open');
        }
    }

    hoverNegozio() {
        if (this.negozio.classList.contains('open') || isAllMobileDevices) return
        this.paint()
    }

    leaveNegozio() {
        if (this.negozio.classList.contains('open') || isAllMobileDevices) return
        this.clean()
    }

    paint() {
        gsap.to(this.negozioTitle, {
            duration: 0.15,
            color: this.colorWhite,
            ease: 'power1.inOut'
        })
        gsap.to(this.negozioBg, {
            duration: 0.15,
            height: '100%',
            ease: 'power1.inOut'
        })
    }

    clean() {
        gsap.to(this.negozioTitle, {
            duration: 0.15,
            color: this.colorBlack,
            ease: 'power1.inOut'
        })
        gsap.to(this.negozioBg, {
            duration: 0.15,
            height: '0%',
            ease: 'power1.inOut'
        })
    }
    closeAltriNegozi() {
        this.negozi.forEach(negozio => {
            if (!negozio.classList.contains('current')) {
                let negozioContainer = negozio.querySelector('.negozio__container')
                let negozioBg = negozio.querySelector('.bg-negozio')
                let titolo = negozio.querySelector('.titolo')
                let plus = negozio.querySelector('.plus')
                gsap.to(titolo, {
                    duration: 0.3,
                    color: this.colorBlack
                })

                gsap.to(negozioBg, {
                    duration: 0.15,
                    height: '0%',
                    ease: 'power1.inOut'
                })

                gsap.to(plus, {
                    duration: 0.3,
                    rotation: 0,
                    ease: 'power1.inOut'
                })
                gsap.to(negozioContainer, {
                    duration: 0.3,
                    height: 0
                });
                negozio.classList.remove('open');
            }
        })
    }

    recalculateOnDeviceRotation() {
        //TODO: Per il desktop orintationchange è deprecata, consigliano di non usarla (link https://developer.mozilla.org/en-US/docs/Web/API/Window/orientationchange_event#browser_compatibility)
        window.addEventListener('orientationchange', () => {
            // awdScroll.update()
            // console.log('change')

            // this.negozioHeight = this.negozio.querySelector('.negozio__content').getBoundingClientRect().height
            // console.log(this.negozioHeight)
            this.closeNegozio()
        })
        //FIXME: screen.orientation = undefined, anche se su MDN Web Docs dicono che funzioni (link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation/onchange
        // screen.orientation.addEventListener('change', () => {
        //     alert('screen orientation change')
        // })
    }
}

class SingleProductInfoList {
    constructor(infoItem) {
        this.infoItem = infoItem
        this.wrapperTitle = this.infoItem.querySelector('.info__item__head')
        this.title = this.wrapperTitle.querySelector('.info__item__title')
        this.titleBg = this.wrapperTitle.querySelector('.info__item__bg')

        this.infoContent = this.infoItem.querySelector('.info__item__content')
        this.content = this.infoContent.querySelector('.content')
        this.contentHeight = this.content.getBoundingClientRect().height
        this.plus = this.infoItem.querySelector('.icon .plus')
        this.plusSvg = [...this.plus.querySelectorAll('.svg-plus')]

        this.infoItems = [...document.querySelectorAll('.info__item')]

        this.colorBlack = '#000000'
        this.colorWhite = '#ffffff'

        this.initEvents()
    }


    initEvents() {
        this.infoItem.addEventListener('mouseover', () => {
            this.hoverItem()
        })
        this.infoItem.addEventListener('mouseleave', () => {
            this.leaveItem()
        })
        this.wrapperTitle.addEventListener('click', () => {
            awdScroll.stop()
            if (globalIsAnimating) return
            globalIsAnimating = true
            if (this.infoItem.classList.contains('open')) {
                this.closeInfoItem();
            }
            else {
                this.openInfoItem();
            }
            awdScroll.start()
        })
        awdScroll.on('scroll', args => {
            // console.log(args.speed)
            if (document.querySelector('.info__item.open') !== null && Math.abs(args.speed) > 10) {

                this.infoItems.forEach(infoItem => {
                    // if(!infoItem.classList.contains('current')){
                    let content = infoItem.querySelector('.info__item__content')
                    let itemBg = infoItem.querySelector('.info__item__bg')
                    let titolo = infoItem.querySelector('.info__item__title')
                    let plus = infoItem.querySelector('.plus')
                    let plusSvg = [...infoItem.querySelectorAll('.svg-plus')]
                    gsap.to(titolo, {
                        duration: 0.3,
                        color: this.colorBlack
                    })

                    gsap.to(itemBg, {
                        duration: 0.15,
                        height: '0%',
                        ease: 'power1.inOut'
                    })

                    gsap.to(plus, {
                        duration: 0.3,
                        rotation: 0,
                        ease: 'power1.inOut'
                    })
                    gsap.to(content, 0.4, {
                        height: 0
                    })
                    gsap.to(plusSvg, {
                        duration: 0.15,
                        fill: this.colorBlack
                    })
                    infoItem.classList.remove('open');
                    // }
                })
            }
        })
    }

    hoverItem() {
        if (this.infoItem.classList.contains('open')) return
        this.paint()
    }

    leaveItem() {
        if (this.infoItem.classList.contains('open')) return
        this.clean()

    }
    paint() {
        gsap.to(this.title, {
            duration: 0.15,
            color: this.colorWhite,
            ease: 'power1.inOut'
        })
        gsap.to(this.titleBg, {
            duration: 0.15,
            height: '100%',
            ease: 'power1.inOut'
        })
        gsap.to(this.plusSvg, {
            duration: 0.15,
            fill: this.colorWhite
        })
    }
    clean() {
        gsap.to(this.title, {
            duration: 0.15,
            color: this.colorBlack,
            ease: 'power1.inOut'
        })
        gsap.to(this.titleBg, {
            duration: 0.15,
            height: '0%',
            ease: 'power1.inOut'
        })
        gsap.to(this.plusSvg, {
            duration: 0.15,
            fill: this.colorBlack
        })
    }


    openInfoItem() {
        this.infoItem.classList.add('current')
        this.paint()
        // let headerHeight = document.querySelector('header').getBoundingClientRect().height
        gsap.to(this.infoContent, {
            duration: 0.4,
            height: this.contentHeight,
            ease: 'Power2.inOut',
            onComplete: () => {
                this.infoItem.classList.remove('current');
                globalIsAnimating = false;
                awdScroll.update()
                // awdScroll.scrollTo(this.wrapperTitle,{
                // 	offset:-headerHeight,
                // 	// offset:500,
                // 	duration:500,
                // 	easeing:[1,0,0,1]
                // });

            }
        });
        gsap.to(this.plus, {
            duration: 0.4,
            rotation: 45,
            ease: 'power1.inOut'
        })
        this.infoItem.classList.add('open');
        this.closeOtherItems();
    }

    closeInfoItem() {
        if (this.infoItem.classList.contains('open')) {
            this.clean()
            gsap.to(this.infoContent, {
                duration: 0.3,
                height: 0,
                onComplete: () => {
                    globalIsAnimating = false;
                    awdScroll.update()
                }
            });

            gsap.to(this.plus, {
                duration: 0.4,
                rotation: 0,
                ease: 'power1.inOut'
            })
            this.infoItem.classList.remove('open');
        }

    }
    closeOtherItems() {
        this.infoItems.forEach(infoItem => {
            if (!infoItem.classList.contains('current')) {
                let content = infoItem.querySelector('.info__item__content')
                let itemBg = infoItem.querySelector('.info__item__bg')
                let titolo = infoItem.querySelector('.info__item__title')
                let plus = infoItem.querySelector('.plus')
                let plusSvg = [...infoItem.querySelectorAll('.svg-plus')]
                gsap.to(titolo, {
                    duration: 0.3,
                    color: this.colorBlack
                })

                gsap.to(itemBg, {
                    duration: 0.15,
                    height: '0%',
                    ease: 'power1.inOut'
                })

                gsap.to(plus, {
                    duration: 0.3,
                    rotation: 0,
                    ease: 'power1.inOut'
                })
                gsap.to(content, 0.4, {
                    height: 0
                })
                gsap.to(plusSvg, {
                    duration: 0.15,
                    fill: this.colorBlack
                })
                infoItem.classList.remove('open');
            }
        })
    }
}

class SingleProductZoom {
    constructor() {
        this.galleryFull = document.querySelector('.gallery-full')
        this.fullContainer = this.galleryFull.querySelector('.full__container')
        this.gallerySingleProduct = [...document.querySelectorAll('.page-single-product .gallery__image')]
        this.fullImage1 = document.getElementById('full-image--1')
        this.fullImageHeight = this.fullImage1.getBoundingClientRect().height
        this.closeFullGallery = this.galleryFull.querySelector('.full__close')
        this.isZooming = false
        this.initEvents()
    }

    initEvents() {

        this.gallerySingleProduct.forEach(image => {
            image.addEventListener('click', () => {
                // let qualeSlide = this.openFullGallery.dataset.slideToOpen
                let qualeSlide = image.getAttribute('data-slide')
                if (this.isZooming) return
                this.isZooming = true
                this.openZoom(qualeSlide)
            })
        })
        //Close Zoom gallery
        this.closeFullGallery.addEventListener('click', () => {
            if (this.isZooming) return
            this.isZooming = true
            this.closeZoom()
        })
        //Chiudo la zoom gallery anche cliccando su un qualsiasi punto
        this.fullContainer.addEventListener('click', () => {
            if (this.isZooming) return
            this.isZooming = true
            this.closeZoom()
        })
    }


    openZoom(qualeSlide) {
        if (awdScroll) {
            awdScroll.stop();
        }
        gsap.to(this.galleryFull, {
            duration: 0.6,
            autoAlpha: 1,
            onComplete: () => {
                this.isZooming = false;
            }
        })

        gsap.to(this.fullContainer, {
            duration: 0,
            // scrolla alla base della foto e lascia intravedere quella successiva
            scrollTo: (this.fullImageHeight * qualeSlide) - winsize.height + 20

        })
    }

    closeZoom() {
        gsap.to(this.galleryFull, {
            duration: 0.4,
            autoAlpha: 0,
            onComplete: () => {
                this.isZooming = false;
            }
        })
        awdScroll.start();

    }
}

class SingleProductNavigation {
    constructor() {
        this.galleryNavigation = document.querySelector('.gallery__navigation')
        this.navigationItems = [...this.galleryNavigation.querySelectorAll('.navigation__item')]
        this.galleryWrapper = document.querySelector('.gallery__wrapper')
        this.galleryImages = [...this.galleryWrapper.querySelectorAll('.gallery__image')]
        this.imagesBuoundingRect = this.galleryImages.map(image => {
            // console.log(image)
            return image.getBoundingClientRect()
        })
        this.productImageHeight = this.imagesBuoundingRect[0].height
        // console.log(this.imagesBuoundingRect)
        this.prevImage = 1
        this.currentImage = 1
        this.scrollLimit = winsize.height * 0.5
        this.initEvents()
    }

    initEvents() {
        this.navigationItems[0].classList.add('animated')
        this.navigationItems.forEach(item => {
            item.addEventListener('click', () => {
                let qualeSlide = item.getAttribute('data-slide')
                let target = this.imagesBuoundingRect[qualeSlide - 1].y + this.productImageHeight - winsize.height
                awdScroll.scrollTo(target, {
                    duration: 500,
                    offset: 10,
                    easing: [0.5, 0.00, 0.5, 1.00]
                })
            })
        })

        awdScroll.on('scroll', () => {
            this.scrollImages()
        })
    }

    scrollImages() {
        this.galleryImages.forEach((galleryImage, index) => {
            let galleryImageClientRect = galleryImage.getBoundingClientRect()
            let order = index + 1
            if (galleryImageClientRect.top < this.scrollLimit && galleryImageClientRect.bottom > this.scrollLimit) {
                this.prevImage = this.currentImage
                this.currentImage = order
                let elPrev = document.querySelector('.navigation__item[data-slide="' + this.prevImage + '"]')
                let elCurr = document.querySelector('.navigation__item[data-slide="' + this.currentImage + '"]')
                if (!elCurr.classList.contains('animated')) {
                    elPrev.classList.remove('animated')
                    elCurr.classList.add('animated')
                    gsap.to(elPrev, { duration: .35, autoAlpha: 0.3, ease: 'power2.out' })
                    gsap.to(elCurr, { duration: .35, autoAlpha: 1, ease: 'power2.out' })
                }
            }
        })
    }

}

class TornaSu{
	constructor(el){
        if(!el) return
		this.DOM = {el:el},
		this.DOM.svgCircleLarge = this.DOM.el.querySelector('#svgCircleLarge');
		this.DOM.hitArea = this.DOM.el.querySelector('.torna-su__hit-area');
		this.raggio = this.DOM.el.getBoundingClientRect().width / 2;
		this.svgCircleLargeLength = 2*Math.PI*this.raggio;
		this.x = 0
		this.coeff = 0
		this.initEvents();
		// this.toggleView();
		this.isAnimatingArrow = false;
		this.isAnimatingScroll = false;
		// this.ctaCircle = new CtaCircle(this.DOM.el);

	}

	initEvents(){

		gsap.set(this.DOM.svgCircleLarge,{
			strokeDashoffset: this.svgCircleLargeLength - this.coeff
		});
        awdScroll.on('scroll', instance => {
			this.x = (this.svgCircleLargeLength*100)/(instance.limit.y);
			this.coeff = instance.scroll.y * this.x/100;
			gsap.set(this.DOM.svgCircleLarge,{
				strokeDashoffset: this.svgCircleLargeLength - this.coeff
			});
			this.toggleView(instance);
        })


		this.DOM.hitArea.addEventListener('click', () => {
			// utility.clickFeedback();
			awdScroll.scrollTo(0)
		});

		// this.DOM.hitArea.addEventListener('mouseover', () => {
		// 	if(this.isAnimatingArrow) return;
		// 	this.isAnimatingArrow = true;
		// 	this.mouseOver();
		// })
	}

	toggleView(instance){
		if(instance.scroll.y > winsize.height/3){
			if(this.isInview) return;
			this.isInview = true;
			gsap.to(this.DOM.el,{
                duration:0.8,
				x:'0%',
				ease:'power2.easeInOut'
			})
		}
		else {
			if(!this.isInview) return;
			this.isInview = false;
			gsap.to(this.DOM.el,{
                duration:0.8,
				x:'300%',
				ease:'power2.easeInOut'
			})
		}
	}

}
class SingleProductAddToCart {
    constructor() {
        this.product = document.querySelector('.product')
        this.productType = this.product.getAttribute('data-product-type')
        this.addToCartBtn = this.product.querySelector('.add-to-cart-btn')
        this.ctaAddToCart = this.product.querySelector('.cta-add-to-cart')

        this.sizesWrapper = this.product.querySelector('.sizes__items')
        this.sizes = [...this.product.querySelectorAll('.product__sizes .size')]

        this.alertSizeTxt = this.product.querySelector('.sizes__alert')

        this.iconaBagQty = document.querySelector('.js-bag-counter')
        if(this.productType === 'variable-product'){
            this.isSizeSelected = false
        }
        else{
            this.isSizeSelected = true
        }
        this.isAnimating = false

        this.initEvents()

    }

    initEvents() {

        this.addToCartBtn.addEventListener('click', () => {
            if (!this.isSizeSelected) {
                this.alertNoSizeSelected()
                return
            }
            if (this.isAnimating) return
            this.isAnimating = true
            let sizeId = this.addToCartBtn.getAttribute('data-size-id')
            let productId = this.addToCartBtn.getAttribute('data-product-id')
            let qty = 1
            this.beforeAddToCart()

            addToCart(productId, sizeId, qty).then(() => {
                if(this.productType === 'variable-product'){
                    this.resetAfterAddToCart()
                }
                this.isAnimating = false
            })
        })

        this.sizes.forEach(size => {
            let sizeId = size.getAttribute('data-size-id')
            size.addEventListener('click', () => {
                if (size.classList.contains('non-disponibile')) return
                this.isSizeSelected = true
                gsap.to(this.alertSizeTxt, {
                    duration: 0.4,
                    autoAlpha: 0
                })
                this.sizes.forEach(taglia => {
                    taglia.classList.remove('selected')
                })
                size.classList.add('selected')
                this.addToCartBtn.setAttribute('data-size-id', sizeId)
                this.ctaAddToCart.classList.remove('disabled')
                // console.log(sizeId)
            })
        })
    }

    alertNoSizeSelected() {
        gsap.to(this.alertSizeTxt, {
            duration: 0.2,
            autoAlpha: 1,
            onComplete: () => {
                gsap.timeline({ repeat: 2 })
                    .to(this.alertSizeTxt, {
                        duration: 0.05,
                        x: 20
                    })
                    .to(this.alertSizeTxt, {
                        duration: 0.05,
                        x: 0
                    })
            }
        })
    }

    resetAfterAddToCart() {
        this.ctaAddToCart.classList.add('disabled')
        this.isSizeSelected = false
        this.sizes.forEach(size => {
            size.classList.remove('selected')
        })
    }

    beforeAddToCart() {
        gsap.to(this.iconaBagQty, {
            duration: 0.4,
            autoAlpha: 0
        })
        gsap.to(classMinicart.minicart, {
            duration: 0,
            autoAlpha: 1
        })
        gsap.to(classMinicart.minicartBg, {
            duration: 0.6,
            autoAlpha: 1,
            delay: 0.3
        })
    }

}

function addToCart(productId, sizeId, qty) {
    return new Promise(resolve => {
        let action = 'add_to_cart'
        let formData = new FormData()
        formData.append('productId', productId)
        formData.append('sizeId', sizeId)
        formData.append('qty', qty)
        formData.append('action', action)
        // let url = document.getElementById('uri').value + '/AJAX/cart.php'

        let url = homeUrl + '/opzione-sito/ajax-cart'
        let request = new XMLHttpRequest()
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                // console.log(res)
                classMinicart.updateMinicart()
                updateIconBagCount(res.total_prods)
                //Serve per il custom data layer del tag manager (gtm)
				const addToCartEvent = new CustomEvent("addToCart", {
					bubbles: true,
					detail: { productId: productId, sizeId: sizeId},
				})
				window.dispatchEvent(addToCartEvent)

                resolve()

            }
        }
        request.send(formData)
    })
}

function removeFromCart(key) {
    return new Promise(resolve => {
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'remove_from_cart')
        formData.append('key', key)
        let url = document.getElementById('uri').value + '/AJAX/cart.php'
        request.open('POST', url, true)
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                if (parseInt(res.total_prods) == 0) {
                    classMinicart.closeMinicart();
                }
                updateIconBagCount(res.total_prods)
                resolve(res)
            }
        }
    })
}

function updateIconBagCount(totalProducts) {
    let iconaBagQty = document.querySelector('.js-bag-counter')
    iconaBagQty.innerHTML = totalProducts;
    gsap.to(iconaBagQty, {
        duration: 0.4,
        autoAlpha: 1
    })
}

class BtnListaTaglie {
    constructor(btn) {
        this.btn = btn
        this.product = this.btn.closest('.product') || this.btn.closest('.related__product') || this.btn.closest('.row__item')
        this.cta = this.btn.querySelector('.add-to-cart')
        this.allButtons = [...document.querySelectorAll('.apri-lista-taglie-btn')]
        this.listaTaglie = this.btn.querySelector('.lista-taglie')
        this.listaTaglieWrapper = this.btn.querySelector('.lista-taglie__wrapper')
        this.altezzaTarget = this.listaTaglieWrapper.getBoundingClientRect().height
        this.targetToScroll = this.listaTaglieWrapper
        this.isAnimating = false
        this.isSomeListOpened = false
        this.initEvents()
    }

    initEvents() {

        this.btn.addEventListener('click', event => {
            event.stopPropagation()
            if (this.isAnimating) return
            this.isAnimating = true
            if (this.btn.classList.contains('opened')) {
                this.mostraCta()
                this.chiudiListaTaglie().then(() => this.isAnimating = false)
                this.btn.classList.remove('opened')
                this.isSomeListOpened = false
            }
            else {
                this.resettaListeAperte()
                this.calcolaAltezzaTaglie()
                this.scrollToTarget()
                this.nascondiCta()
                this.apriListaTaglie().then(() => this.isAnimating = false)
                this.btn.classList.add('opened')
                this.isSomeListOpened = true
            }
        })
    }

    resettaListeAperte() {
        return new Promise(resolve => {
            [...document.querySelectorAll('.apri-lista-taglie-btn')].forEach(btn => {
                if (btn.classList.contains('opened')) {
                    let listaAperta = btn.querySelector('.lista-taglie')
                    let cta = btn.querySelector('.add-to-cart')
                    gsap.to(listaAperta, {
                        duration: 0.3,
                        ease: 'power1.inOut',
                        height: 0,
                        onComplete: () => {
                            resolve()
                        }
                    })
                    gsap.to(cta, {
                        duration: 0.3,
                        autoAlpha: 1
                    });
                    btn.classList.remove('opened')
                }
            })

        })
    }

    calcolaAltezzaTaglie() {
        this.altezzaListaTaglie = this.listaTaglieWrapper.getBoundingClientRect().height
    }
    scrollToTarget() {
        if(isMobile === 'portrait'){
            let container = document.querySelector('#container')
            gsap.to(container, {
                duration: 0.3,
                scrollTo: this.product

            })
        }
        else{
            awdScroll.scrollTo(this.product, {
                offset: winsize.width / 10,
                easeing: [0.5, 0, 0.5, 1]
            })

        }
    }
    apriListaTaglie() {
        return new Promise(resolve => {
            gsap.to(this.listaTaglie, {
                duration: 0.3,
                ease: 'power1.inOut',
                height: this.altezzaTarget,
                onComplete: () => {
                    resolve()
                }
            })

        })
    }
    chiudiListaTaglie() {
        return new Promise(resolve => {
            gsap.to(this.listaTaglie, {
                duration: 0.3,
                ease: 'power1.inOut',
                height: 0,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }
    nascondiCta() {
        gsap.to(this.cta, {
            duration: 0.3,
            autoAlpha: 0
        })
    }
    mostraCta() {
        gsap.to(this.cta, {
            duration: 0.3,
            autoAlpha: 1
        })
    }
}

class Minicart {
    constructor(minicart) {

        this.minicart = minicart
        this.minicartWrapper = this.minicart.querySelector('.minicart__wrapper')
        this.minicartBg = this.minicart.querySelector('.minicart__bg')
        this.minicartContainer = this.minicart.querySelector('.minicart__container')

        this.iconaBagQty = document.querySelector('.js-bag-counter')

        this.isAnimating = false

        this.init()

    }

    //Eventi che possono essere inizializzati senza dover reinizializzare dopo le chiamate AJAX
    init() {
        this.minicartBg.addEventListener('click', () => {
            if (this.isAnimating) return
            this.isAnimating = true;
            this.closeMinicart();
        });
    }

    updateMinicart() {
        let formData = new FormData()
        let request = new XMLHttpRequest()
        // let url = document.getElementById('uri').value + '/AJAX/cart.php'
        let url = homeUrl + '/opzione-sito/ajax-cart'
        formData.append('action', 'update_minicart')
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = request.response
                // console.log(res)
                this.minicartContainer.innerHTML = res
                // if(isMobile){
                // 	setMinicartHeightMobile()
                // }

                this.minicart.classList.add('opened')
                this.openMinicart()
            }
        }
        request.send(formData)
    }


    openMinicart() {
        gsap.timeline()
            .to(this.minicartContainer, {
                duration: 1.2,
                ease: 'power2.inOut',
                x: '0%',
                onComplete: () => {
                    this.initAjaxEvents()
                    this.isAnimating = false
                }
            })
    }

    closeMinicart() {
        this.minicart.classList.remove('opened');
        gsap.timeline()
            .to(this.minicartContainer, {
                duration: 1.2,
                ease: 'power2.inOut',
                x: '100%'
            })
            .to(this.minicartBg, {
                duration: 0.6,
                autoAlpha: 0
            }, '-=0.2')
            .to(this.minicart, {
                duration: 0,
                autoAlpha: 0
            })
            .add(() => {
                // if(awdScroll){
                // 	awdScroll.start();
                // }
                // if(isMobile){
                // 	body.style.overflow = 'visible';
                // }
                this.isAnimating = false;
            })
    }

    //Reinizializzo gli elementi e riattivo le funzioni dopo la chiamata AJAX
    initAjaxEvents() {
        this.totalPriceContainers = [...this.minicart.querySelectorAll('.subtotale__container')];

        this.closeMinicartBtns = [...this.minicart.querySelectorAll('.close-minicart-btn')]
        this.closeMinicartBtns.forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                this.closeMinicart()
            })
        })

        this.contentWrapper = this.minicart.querySelector('.content__wrapper');
        new SimpleBar(this.contentWrapper, { autoHide: true });

        this.removeBtns = [...this.minicart.querySelectorAll('.remove-item')]
        this.removeBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                let key = btn.closest('.minicart__item').getAttribute('data-key')
                this.beforeRemoveItem(key)
                removeFromCart(key).then(res => {
                    // console.log(res)
                    this.totalPriceContainers.forEach( container => {
                        container.querySelector('.value').innerHTML = res.total
                    })
                    gsap.to(this.totalPriceContainers, {
                        duration: 0.4,
                        autoAlpha: 1
                    })
                    this.isAnimating = false
                })
            })
        })
    }


    beforeRemoveItem(key) {
        let itemDeleted = this.minicart.querySelector('.minicart__item[data-key="' + key + '"]')
        gsap.to(this.totalPriceContainers, {
            duration: 0.4,
            autoAlpha: 0
        })
        gsap.to(itemDeleted.querySelector('.minicart__item__wrapper'), {
            duration: 0.4,
            autoAlpha: 0
        })
        gsap.to(itemDeleted, {
            height: 0,
            onComplete: () => {
                itemDeleted.remove()
            }
        })
        gsap.to(this.iconaBagQty, {
            duration: 0.4,
            autoAlpha: 0
        })
    }
}




class StickyElement {
    constructor(el, target) {
        // console.log(el, target)
        this.element = el
        this.elementHeight = el.getBoundingClientRect().height
        this.elementOffset = el.getBoundingClientRect().y

        if (target !== null) {
            this.targetHeight = target.getBoundingClientRect().height
            this.targetOffset = target.getBoundingClientRect().y
            this.limit = this.targetHeight + this.targetOffset - this.elementHeight - this.elementOffset
            this.stickyWithTarget()
        }
        else {
            this.stickyAlwaysFixed()
        }
    }

    stickyWithTarget() {
        awdScroll.on('scroll', (args) => {
            if (args.scroll.y > this.limit) {
                gsap.to(this.element, {
                    duration: 0,
                    y: this.limit
                })
            }
            //fixed phase
            else {
                gsap.to(this.element, {
                    duration: 0,
                    y: args.scroll.y
                })
            }
        })
    }

    stickyAlwaysFixed() {
        awdScroll.on('scroll', (args) => {
            gsap.to(this.element, {
                duration: 0,
                y: args.scroll.y
            })
        })
    }
}

class LoginPopup {
    constructor() {
        this.headerLogin = document.querySelector('.header-login')
        this.loginPopup = document.querySelector('.login-popup')
        this.loginPopupWrapper = this.loginPopup.querySelector('.login-popup__wrapper')
        this.loginPopupForm = this.loginPopup.querySelector('.login-popup__form')
        this.loginPopupBg = this.loginPopup.querySelector('.login-popup__bg')
        this.closeBtn = this.loginPopup.querySelector('.close-login-popup-btn')
        this.isAnimating = false
        this.initEvents()

    }

    initEvents() {
        this.headerLogin.addEventListener('click', () => {
            if (this.headerLogin.classList.contains('opened')) {
                this.closeLoginPopup()
            }
            else {
                this.openLoginPopup()
            }
        })

        this.closeBtn.addEventListener('click', () => {
            this.closeLoginPopup()
        })

        this.loginPopupBg.addEventListener('click', () => {
            this.closeLoginPopup()
        })

    }

    openLoginPopup() {
        if (this.isAnimating) return
        this.isAnimating = true
        this.loginPopup.style.display = 'block'
        if(isMobile === 'landscape'){
            setBodyOverflowHidden()
        }
        let loginPopupWidth = this.loginPopupForm.getBoundingClientRect().width
        gsap.to(this.loginPopupBg, {
            duration: 0.3,
            autoAlpha: 1
        })
        gsap.to(this.loginPopupWrapper, {
            duration: 0.4,
            width: loginPopupWidth,
            ease: 'power2.inOut',
            onComplete: () => {
                this.isAnimating = false
            }
        })
        if (document.querySelector('.filters') !== null) {
            gsap.to(document.querySelector('.filters'), {
                duration: 0.2,
                autoAlpha: 0,
                onComplete: () => {
                    classFilters.closeFilters()
                }
            })
        }
        this.headerLogin.classList.add('opened')
    }

    closeLoginPopup() {
        if (this.isAnimating) return
        this.isAnimating = true
        // let loginPopupWidth = this.loginPopupForm.getBoundingClientRect().width
        if(isMobile === 'landscape'){
            setBodyOverflowVisible()
        }
        gsap.to(this.loginPopupBg, {
            duration: 0.3,
            autoAlpha: 0,
            delay: 0.2,
            onComplete: () => {

                if (document.querySelector('.filters') !== null) {
                    gsap.to(document.querySelector('.filters'), {
                        duration: 1,
                        autoAlpha: 1
                    })
                }
                this.isAnimating = false
                this.loginPopup.style.display = 'none'
            }
        })
        gsap.to(this.loginPopupWrapper, {
            duration: 0.4,
            ease: 'power2.inOut',
            width: 0
        })
        this.headerLogin.classList.remove('opened')

    }
}

class InputText {
    constructor(input) {
        this.input = input
        this.label = this.input.closest('.form__row').querySelector('.label');
        if (!this.input.classList.contains('input--textarea')) {
            this.inputField = this.input.querySelector('input')
        }
        else {
            this.inputField = this.input.querySelector('textarea')
        }
        if (this.input.classList.contains('input--password')) {
            this.viewPasswordBtn = this.input.querySelector('.view-password-btn')
        }
        if (this.input.closest('.error-check-container') !== null) {
            this.errorCheckContainer = this.input.closest('.error-check-container')
            this.labelError = this.errorCheckContainer.querySelector('.label__error')
            this.labelErrorSpan = this.labelError.querySelector('span')
            this.defaultLabelErrorTxt = this.labelErrorSpan.innerHTML
        }
        this.isInputEmail = false


        this.originalColorBorder = getComputedStyle(this.input).borderColor

        if (this.input.classList.contains('input--email')) {
            this.isInputEmail = true
        }
        if (this.input.classList.contains('input--email--newsletter-footer')) {
            this.isInputEmailNewsletterFooter = true
        }
        this.duration = 0.4


        this.initEvents();
    }

    initEvents() {
        let topFocus = '0%'
        // let topStart = '50%'
        if (this.isInputEmailNewsletterFooter) {
            topFocus = '-15%'
        }
        if (this.inputField.value !== '') {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
                borderColor: colorSuccess
            });
            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus
            })

        }

        this.inputField.addEventListener('focus', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 3,
            })

            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus
            })
            // if(this.input.classList.contains('exclude-quick-check')){
            this.hideError()
            this.borderStandby()
            // }
        })

        this.inputField.addEventListener('blur', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
            })
            if (this.inputField.value == '') {
                gsap.to(this.label, {
                    duration: this.duration,
                    top: '50%'
                })
            }
            //Esempio: per il coupon non serve che controllo al blur o keyup
            // if(!this.input.classList.contains('exclude-quick-check')){
            this.hideError()
            this.borderStandby()
            // }
        })

        this.inputField.addEventListener('keyup', () => {
            if (this.input.closest('.error-check-container') !== null && this.errorCheckContainer.classList.contains('errore-attivo')) {
                //Esempio: per il coupon non serve che controllo al blur/keyup
                if (!this.input.classList.contains('exclude-check-focus')) {
                    // this.checkStatus()
                }
            }
            if (this.inputField.getAttribute('type') === 'email' && (document.querySelector('.page-contatti') !== null || document.querySelector('.page-apri-con-noi') !== null)) {
                let thankyou = document.querySelector('.thankyou-contatti')
                thankyou.querySelector('.js-email').innerHTML = this.inputField.value
            }
            // if (this.inputField.classList.contains('email-reso')) {
            // 	let thankyou = document.querySelector('.thankyou-reso')
            // 	thankyou.querySelector('.js-email').innerHTML = this.inputField.value
            // }
        })

        //Alcuni campi potrebbero essere precompilati, quindi chekko anche all'init
        if (this.inputField.getAttribute('type') === 'email' && (document.querySelector('.page-contatti') !== null || document.querySelector('.page-apri-con-noi') !== null)) {
            let thankyou = document.querySelector('.thankyou-contatti')
            thankyou.querySelector('.js-email').innerHTML = this.inputField.value
        }
        // if(this.inputField.classList.contains('email-reso')){
        // 	let thankyou = document.querySelector('.thankyou-reso')
        // 	thankyou.querySelector('.js-email').innerHTML = this.inputField.value
        // }
        // if(this.inputField.classList.contains('email-assistenza')){
        // 	let thankyou = document.querySelector('.thankyou-contatti')
        // 	thankyou.querySelector('.js-email').innerHTML = this.inputField.value
        // }


        if (this.input.classList.contains('input--password')) {
            this.viewPasswordBtn.addEventListener('click', () => {
                this.toggleViewPassword()
            })
        }
    }
    toggleViewPassword() {
        // console.log('click')
        if (this.inputField.type === "password") {
            this.inputField.type = "text"
        } else {
            this.inputField.type = "password"
        }
    }
    resetField() {
        this.inputField.value = ''
    }

    checkStatus() {
        if (this.input.classList.contains('campo-obbligatorio')) {
            let inputValue = this.inputField.value
            let errorValue = ''
            //campo txt
            if (!this.isInputEmail) {
                if (inputValue == '') {

                    if (this.input.closest('.error-check-container') !== null) {
                        this.resetTextError()
                    }
                    this.showError()
                    // this.borderActiveWrong()
                    errorValue = 'si'
                }
                else {
                    this.hideError()
                    // this.borderActiveCorrect()
                    errorValue = 'no'
                }
            }
            //campo email
            else {
                if (inputValue == '') {
                    // this.resetTextError()
                }
                if (!validateEmail(inputValue)) {
                    this.showError()
                    // this.borderActiveWrong()
                    errorValue = 'si'
                }
                else {
                    this.hideError()
                    // this.borderActiveCorrect()
                    errorValue = 'no'
                }

            }
            return errorValue
        }
    }

    // setTextError(txt){
    //     this.labelErrorSpan.innerHTML = txt
    // }
    resetTextError() {
        this.labelErrorSpan.innerHTML = this.defaultLabelErrorTxt
    }

    showError() {
        gsap.to(this.labelError, {
            duration: this.duration,
            autoAlpha: 1
        });
        this.errorCheckContainer.classList.add('errore-attivo');
    }
    hideError() {
        gsap.to(this.labelError, {
            duration: this.duration,
            autoAlpha: 0
        });
        this.errorCheckContainer.classList.remove('errore-attivo');
    }
    borderActiveCorrect() {
        gsap.to(this.input, {
            duration: this.duration,
            borderColor: colorSuccess
        });
    }
    borderActiveWrong() {
        gsap.to(this.input, {
            duration: this.duration,
            borderColor: colorError
        });
    }
    borderStandby() {
        gsap.to(this.input, {
            duration: this.duration,
            borderColor: this.originalColorBorder
        });

    }
}

class Checkbox {
    constructor(cb) {
        this.cb = cb
        this.unchecked = this.cb.querySelector('.unchecked')
        this.svgUnchecked = this.cb.querySelector('.svg-unchecked')
        this.checked = this.cb.querySelector('.checked')
        this.svgChecked = this.cb.querySelector('.svg-checked')
        this.txt = this.cb.querySelector('.checkbox__txt')
        this.txtSpan = this.txt.querySelector('span')
        if (this.txt.querySelector('a') !== null) {
            this.txtAnchor = this.txt.querySelector('a')
            this.originalColorLink = getComputedStyle(this.txtAnchor).color
        }

        this.originalColorTxt = getComputedStyle(this.txtSpan).color

        this.initEvents()
    }
    initEvents() {
        this.cb.addEventListener('click', () => {
            this.changeCheckboxStatus()
        })
    }

    changeCheckboxStatus() {
        this.dataCheckboxStatus = this.cb.getAttribute('data-checkboxstatus')
        if (this.dataCheckboxStatus == 'checked') {
            gsap.to(this.checked, 0.6, {
                autoAlpha: 0
            })
            this.cb.dataset.checkboxstatus = 'unchecked'
        }
        else {
            gsap.to(this.checked, 0.6, {
                autoAlpha: 1
            })
            gsap.to(this.svgUnchecked, 0.6, {
                // stroke:colorBlack
                stroke: this.originalColorTxt
            })
            gsap.to(this.txtSpan, 0.6, {
                color: this.originalColorTxt
            })
            if (this.txt.querySelector('a') !== null) {
                gsap.to(this.txtAnchor, {
                    duration: 0.6,
                    // color:colorBlack
                    color: this.originalColorLink
                })
            }
            this.cb.dataset.checkboxstatus = 'checked'
        }
    }

    checkStatus() {
        if (this.cb.classList.contains('campo-obbligatorio')) {
            this.dataCheckboxStatus = this.cb.getAttribute('data-checkboxstatus')
            let errorValue = ''
            if (this.dataCheckboxStatus == 'unchecked') {
                gsap.to(this.svgUnchecked, 0.6, {
                    stroke: colorError
                })
                gsap.to(this.txtSpan, 0.6, {
                    color: colorError
                })
                if (this.txt.querySelector('a') !== null) {
                    gsap.to(this.txtAnchor, 0.6, {
                        color: colorError
                    })
                }
                errorValue = 'si'
            }
            else {
                errorValue = 'no'
            }
            return errorValue
        }
    }
}

class Form {
    constructor(form) {
        this.form = form
        this.formName = this.form.getAttribute('data-formname')
        // console.log(this.formName)

        this.isWaiting = false
        this.isAnimating = false

        if (this.form.querySelector('.submit') !== null) {
            this.submit = this.form.querySelector('.submit')
            this.submitTxt = this.submit.querySelector('.txt')
            this.ctaTxt = this.submitTxt.innerHTML

        }

        if (this.form.querySelector('.errore-generico') !== null) {
            this.erroreGenerico = this.form.querySelector('.errore-generico')
            this.erroreGenericoTxt = this.erroreGenerico.querySelector('.txt')
            this.erroreGenericoDefaultTxt = this.erroreGenericoTxt.innerHTML
        }

        this.checkboxesObbligatorie = this.form.querySelectorAll('.checkbox.campo-obbligatorio')
        this.arrayCheckoxesObbligatorie = [...this.checkboxesObbligatorie].map(cb => new Checkbox(cb))

        if (this.form.querySelectorAll('.input') !== null) {
            this.arrayInputs = [...this.form.querySelectorAll('.input')].map(input => new InputText(input));
        }

        if (this.form.querySelectorAll('.select') !== null) {
            this.arraySelects = [...this.form.querySelectorAll('.select')].map(select => new InputSelect(select));
        }

        // this.setRowZindex();
        this.initEvents();

    }

    initEvents() {
        this.form.addEventListener('submit', e => {
            e.preventDefault()
        })
        if (this.form.querySelector('.submit') !== null) {
            this.submit.addEventListener('click', () => {
                if (this.isWaiting) return;
                this.startWaiting()
                this.checkErrors()
            })
        }
    }

    // resetTxtErroreGenerico(){
    //     this.erroreGenericoTxt.innerHTML = this.erroreGenericoDefaultTxt
    // }

    startWaiting() {
        let txt = 'ATTENDERE...'
        if (language !== 'it') {
            txt = 'PLEASE WAIT...'
        }
        this.isWaiting = true
        this.submit.classList.add('is-waiting')
        this.submitTxt.innerHTML = txt
        gsap.to(this.submit, {
            duration: 0,
            cursor: 'default'
        })
        gsap.to(this.submit, {
            duration: 0.4,
            autoAlpha: 0.3
        })
    }

    stopWaiting() {
        this.isWaiting = false
        this.submit.classList.remove('is-waiting');
        this.submitTxt.innerHTML = this.ctaTxt;
        gsap.to(this.submit, {
            duration: 0,
            cursor: 'pointer'
        })
        gsap.to(this.submit, {
            duration: 0.4,
            autoAlpha: 1
        })
    }
    //le select devono coprire gli altri field quando le apro
    // setRowZindex(){
    // 	let arrayFormRows = [...this.form.querySelectorAll('.form__row')];
    // 	let quanteRow = arrayFormRows.length;
    // 	arrayFormRows.forEach( (row, index) => {
    // 		TweenMax.set(row,{
    // 			'z-index': quanteRow - index
    // 		})
    // 	})
    // }

    checkErrors() {
        this.arrayErrors = []

        this.arrayCheckoxesObbligatorie.forEach(checkboxClass => {
            let errorValue = checkboxClass.checkStatus()
            if (errorValue === 'si') {
                this.arrayErrors.push(errorValue)
            }
        })


        this.arrayInputs.forEach(inputCLass => {
            if (inputCLass.input.classList.contains('campo-obbligatorio')) {
                let errorValue = inputCLass.checkStatus()
                if (errorValue === 'si') {
                    this.arrayErrors.push(errorValue)
                }
            }
        })
        // this.arraySelects.forEach( selectCLass => {
        // 	if(selectCLass.select.classList.contains('campo-obbligatorio')){
        // 		let errorValue = selectCLass.checkStatus()
        // 		if(errorValue === 'si'){
        // 			this.arrayErrors.push(errorValue)
        // 		}
        // 	}
        // })

        //se ci sono errori
        if (this.arrayErrors.length > 0) {
            // console.log('ci sono errori')
            if (this.formName !== 'registrazione') {
                if (this.form.querySelector('.errore-generico') !== null) {
                    gsap.to(this.erroreGenericoTxt, {
                        duration: 0.4,
                        autoAlpha: 1
                    })
                }

            }
            // this.scrollToError()
            this.stopWaiting()
            // this.submitForm(this.formName)	//!commentare o cancellare quando si va online

        }
        //se NON ci sono errori
        else {
            // console.log('non ci sono errori')
            if (this.form.querySelector('.errore-generico') !== null) {
                gsap.to(this.erroreGenericoTxt, {
                    duration: 0.4,
                    autoAlpha: 0
                })
            }
            this.submitForm(this.formName)
        }
    }

    thankyouMessage(formName) {
        console.log(formName)
        let thankyou = document.querySelector('.thankyou-' + formName)
        let thankyouBg = thankyou.querySelector('.thankyou__bg span')
        // let thankyouWraper = thankyou.querySelector('.thankyou__wrapper')
        let thankyouTxt = thankyou.querySelectorAll('.thankyou__wrapper p')
        let delay = 8
        // if(this.formName == 'login'){
        // 	delay = 2
        // }
        // if(this.formName == 'registrazione'){
        // 	delay = 2
        // }
        if (this.formName == 'newsletter') {
            delay = 4
        }
        return new Promise((resolve, reject) => {

            gsap.to(thankyou, {
                duration: 0,
                autoAlpha: 1
            })

            gsap.to(thankyouBg, {
                duration: 0.5,
                autoAlpha: 1
            })
            gsap.to(thankyouTxt, {
                duration: 0.5,
                delay: 0.4,
                autoAlpha: 1
            })
            gsap.to(thankyouTxt, {
                duration: 1,
                delay: delay,
                autoAlpha: 0,
                onComplete: () => {
                    resolve();
                }
            })
        })
    }
    submitForm(formName) {
        // console.log(formName)
        if (formName === 'login') {
            this.inviaFormLogin()
        }
        else if (formName === 'contatti') {
            this.inviaFormContatti()
        }
        else if (formName === 'newsletter') {
            this.inviaFormNewsletter()
        }
        else if (formName === 'registrazione') {
            this.inviaFormRegistrazione()
        }
        else if (formName === 'apri-con-noi') {
        	this.inviaFormApriConNoi()
        }
        // else if (formName === 'reso') {
        // 	this.inviaFormReso()
        // }
        // else if (formName === 'assistenza') {
        // 	this.inviaFormAssistenza()
        // }
    }
    inviaFormLogin() {
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        // let redirectLink = homeUrl
        formData.append('action', 'login_user')
        // formData.append('lang', getCookie('wp-wpml_current_language'))
        // formData.append('user', user)
        // formData.append('pass', pass)
        // formData.append('remember', remember)
        let url = document.getElementById('uri').value + '/AJAX/user.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // console.log(request)
                let res = JSON.parse(request.response)
                console.log(res.return)
                if (res.return == '200') {
                    return new Promise(resolve => {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 0,
                            onComplete: () => {
                                this.erroreGenericoTxt.style.color = colorSuccess
                                if (language === 'it') {
                                    this.erroreGenericoTxt.innerHTML = 'login effettuato con successo'
                                }
                                else {
                                    this.erroreGenericoTxt.innerHTML = 'login successful'
                                }
                                resolve()
                            }
                        })



                    }).then(() => {
                        return new Promise(resolve => {
                            gsap.to(this.erroreGenericoTxt, {
                                duration: 0.4,
                                autoAlpha: 1,
                                onComplete: () => {
                                    setTimeout(() => {
                                        resolve()
                                    }, 1000)
                                }
                            })
                        })
                    }).then(() => {
                        location.reload()
                    })
                }
                else {
                    this.stopWaiting()
                    if (this.form.querySelector('.errore-generico') !== null) {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 1
                        })
                    }

                    // async function add(stringa){
                    // 	let prom = await test(string)
                    // 	console.log('sbagliooooo')
                    // }

                    // if (res.target == 'user') {
                    // 	that.loginUsername.closest('.login-item').querySelector('.error').innerHTML = res.return
                    // 	gsap.to(that.loginUsername.closest('.login-item').querySelector('.error'), { duration: 0.3, autoAlpha: 1, ease: "power2.inOut" })
                    // } else {
                    // 	that.loginpassword.closest('.login-item').querySelector('.error').innerHTML = res.return
                    // 	gsap.to(that.loginpassword.closest('.login-item').querySelector('.error'), { duration: 0.3, autoAlpha: 1, ease: "power2.inOut" })
                    // }
                }
            }
        }
        request.send(formData)


    }
    inviaFormContatti() {
        // console.log('invia form')
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/contacts.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                //Stampa il responso se nei file php c'è la riga SMTPDebug = 2
                console.log(request.response)
                // let res = JSON.parse(request.response)
                // console.log(res)

                // if (res.return == '200') {
                this.thankyouMessage('contatti').then(() => {
                    window.location.reload()
                })

                // }

            }
        }
        request.send(formData)

    }
    inviaFormApriConNoi() {
        // console.log('invia form apri con noi')
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/richiesta-franchising.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // let res = JSON.parse(request.response)
                // console.log(res)

                // if (res.return == '200') {
                this.thankyouMessage('contatti').then(() => {
                    window.location.reload()
                })

                // }

            }
        }
        request.send(formData)

    }

    inviaFormNewsletter() {
        //Da Agosto/Settembre 2023 le chiamate API di 4DEm vengono bloccate dal CORS, per cui passiamo alle chiamate API con PHP che bypassano questo problema
		// let body = {
		// 	"email_address": this.form.querySelector('input[name="EMAIL"]').value,
		// 	"subscription": {
		// 		"ip": document.getElementById('newsletter-ip').value.toUpperCase(),
		// 		"status": "Subscribed"
		// 	},
		// 	"triggers": {
		// 		"automation": true,
		// 		"behaviors": false,
		// 		"send_confirmation_email": true
		// 	},
		// 	"update_if_duplicate": true,
		// }
		let lista = 92525
        let emailAddress = this.form.querySelector('input[name="EMAIL"]').value
		// this.fetch4DEMApi(body, lista)
		this.fetch4DEMApi(lista, emailAddress)


        // let formData = new FormData(this.form);
        // let request = new XMLHttpRequest();
        // formData.append('action', 'submit_newsletter')
        // let url = document.getElementById('uri').value + '/AJAX/user.php'
        // request.open('POST', url, true);
        // request.onreadystatechange = () => {
        //     if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
        //         let res = JSON.parse(request.response);
        //         console.log(res)
        //         if (res.response == 200) {
        //             this.thankyouMessage('newsletter').then(() => {
        //                 window.location.reload();
        //             })

        //         }
        //     }
        // };
        // request.send(formData);
    }


	fetch4DEMApi(lista, emailAddress){
        console.log('fetch me')
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        formData.append('action', 'authenticate_user')
        formData.append('lista', lista)
        formData.append('emailAddress', emailAddress)
        let url = document.getElementById('uri').value + '/AJAX/iscrizione-newsletter.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // let res = JSON.parse(request.response)
                // console.log(res.token)
                console.log(request.response)

				this.thankyouMessage('newsletter').then( () => {
					window.location.reload();
				})

            }
        }
        request.send(formData)

	}
    //Da Agosto/Settembre 2023 le chiamate API di 4DEm vengono bloccate dal CORS, per cui passiamo alle chiamate API in PHP che bypassano questo problema
	// fetch4DEMApi(body, lista){
	// 	let that = this;
    //     console.log(lista)
	// 	axios.post('https://api.4dem.it/#/operations/authenticate', {
	// 		APIKey: "c91a-27d0-209e-9e38-26ba-6737-390b-ea60"
	// 	})
	// 	.then(function (res) {
	// 		axios.post(`https://api.4dem.it/recipients/${lista}/subscribe?token=` + res.data.token, body)
	// 		.then(function (response) {
	// 			that.thankyouMessage('newsletter').then( () => {
	// 				window.location.reload();
	// 			})
	// 		})
	// 		.catch(function (error) {
	// 			//Logica per controllo di utente gia esistente ma bisogna passare nel body "update_if_duplicate": false
	// 		});
	// 		//console.log(response);
	// 	})
	// 	.catch(function (error) {
	// 		//gsap.to(that.newsletterLoad, { duration: 0.5, autoAlpha: 0, ease: 'cubic-1'})
	// 		console.log('error', error);
	// 	});
	// }


    inviaFormRegistrazione() {
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let redirectLink = document.querySelector('.page-registrazione').getAttribute('data-redirect')
        formData.append('action', 'register_user')
        let url = document.getElementById('uri').value + '/AJAX/user.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                // console.log(request)
                let res = JSON.parse(request.response)
                console.log(res.return)
                if (res.return == '200') {
                    return new Promise(resolve => {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 0,
                            onComplete: () => {
                                this.erroreGenericoTxt.style.color = colorSuccess
                                if (language === 'it') {
                                    this.erroreGenericoTxt.innerHTML = 'registrazione avvenuta con successo'
                                }
                                else {
                                    this.erroreGenericoTxt.innerHTML = 'registration successful'
                                }
                                resolve()
                            }
                        })
                    }).then(() => {
                        return new Promise(resolve => {
                            gsap.to(this.erroreGenericoTxt, {
                                duration: 0.4,
                                autoAlpha: 1,
                                onComplete: () => {
                                    setTimeout(() => {
                                        resolve()
                                    }, 1000)
                                }
                            })
                        })
                    }).then(() => {
                        // location.reload()
                        window.location.href = homeUrl
                        //Siccome non faccio nè redirect nè reload, resetto tutti i campi e apro in automatico il popup con la form per il login che si trova nell'header
                        // document.querySelector('.header-login').click()
                        // if (this.form.querySelectorAll('.input') !== null) {
                        //     // this.arrayInputs = [...this.form.querySelectorAll('.input')].map(input => new InputText(input))
                        //     this.arrayInputs.forEach(inputClass => {
                        //         inputClass.resetField()
                        //     })
                        // }
                        // this.arrayCheckoxesObbligatorie.forEach(cb => {
                        //     cb.changeCheckboxStatus()
                        // })
                        // gsap.to(this.erroreGenericoTxt, {
                        // 	duration: 0.4,
                        // 	autoAlpha: 0,
                        //     onComplete: () => {
                        //         this.erroreGenericoTxt.innerHTML = this.erroreGenericoDefaultTxt
                        //     }
                        // })
                        // this.stopWaiting()
                    })
                }
                else {
                    this.stopWaiting()
                    if (this.form.querySelector('.errore-generico') !== null) {
                        gsap.to(this.erroreGenericoTxt, {
                            duration: 0.4,
                            autoAlpha: 1
                        })
                    }

                }
            }
        }
        request.send(formData)

    }

}

class Filters {
    constructor(filters) {
        this.filters = filters
        // console.log(this.filters.querySelectorAll('.filter__item.selected').length)
        this.totalActiveFilters = this.filters.querySelectorAll('.filter__item.selected').length
        this.filtersList = this.filters.querySelector('.filters__list')
        this.filtersBg = this.filters.querySelector('.filters__list__bg')
        this.filtersWrapper = this.filters.querySelector('.filters__list__wrapper')
        this.filtersContainer = this.filters.querySelector('.filters__list__container')
        this.filtersHeight = this.filtersContainer.getBoundingClientRect().height
        this.toggleFilters = this.filters.querySelector('.toggle-filters')
        this.toggleFiltersIcon = this.toggleFilters.querySelector('.toggle-filters__icon')
        this.activeFiltersCounter = this.toggleFilters.querySelector('.js-active-filters-counter')
        this.filtersElements = [...this.filters.querySelectorAll('.filter__item')]

        this.applyFiltersWrapper = this.filters.querySelector('.button-apply-filters')
        this.filtersLink = this.applyFiltersWrapper.querySelector('.filters-link')
        this.filtersLinkCta = this.applyFiltersWrapper.querySelector('.cta-apply')


        this.resetFiltersWrpper = this.filters.querySelector('.button--reset-filters')
        this.resetLinkCta = this.resetFiltersWrpper.querySelector('.cta-reset')

        this.originalUrl = this.filters.dataset.originalUrl
        this.cleanUrl = this.filters.dataset.cleanUrl

        this.colorsString = ''
        this.categorieString = ''
        this.taglieString = ''

        this.colori = []
        this.categorie = []
        this.taglie = []

        this.isOpening = false

        this.initEvents()
    }

    initEvents() {

        this.preventLink()
        // this.checkInitialUrl()
        this.initFilters()
        this.selectFilters()
        this.toggleFilters.addEventListener('click', () => {
            if (this.isOpening) return
            this.isOpening = true
            if (!this.filters.classList.contains('opened')) {
                if(isAllMobileDevices){
                    setBodyOverflowHidden()
                }
                if(classCategorieMobile !== null){
                    if(document.querySelector('.lista-categorie').classList.contains('opened')){
                        classCategorieMobile.closeCategorieMobile().then(() => {
                            this.openFilters()
                        }) 
                    }
                    else{
                        this.openFilters()
                    }
                }
                else{
                    this.openFilters()
                }
            }
            else {
                this.closeFilters()
                if(isAllMobileDevices){
                    setBodyOverflowVisible()
                }
            }
        })

        this.filtersBg.addEventListener('click', () => {
            // console.log('click')
            if (this.isOpening) return
            this.isOpening = true
            this.closeFilters()
        })
        this.resetFiltersWrpper.addEventListener('click', () => {
            if(this.resetLinkCta.classList.contains('disabled')) return
            this.resetFilters()
        })
    }

    openFilters() {
        this.filtersList.style.display = 'block'
        this.filtersHeight = this.filtersContainer.getBoundingClientRect().height
        let destinationHeight = this.filtersHeight
        if(isMobile || isTablet ||  isIpadPro == 'landscape'){
            destinationHeight = winsize.height - classHeader.getHeight()
        }
        gsap.to(this.toggleFiltersIcon, {
            duration: 0.4,
            rotation: 45
        })
        gsap.to(this.filtersBg, {
            duration: 0.4,
            autoAlpha: 1
        })
        gsap.to(this.filtersWrapper, {
            duration: 0.6,
            height: destinationHeight,
            ease: 'power2.inOut',
            onComplete: () => {
                this.isOpening = false
                if(isMobile || isTablet || isIpadPro == 'landscape'){
                    this.filtersWrapper.style.overflow = 'scroll'
                }
            }
        })
        this.filters.classList.add('opened')
    }

    closeFilters() {
        return new Promise(resolve => {
            this.filtersWrapper.style.overflow = 'hidden'
            gsap.to(this.toggleFiltersIcon, {
                duration: 0.4,
                rotation: 0
            })
            gsap.to(this.filtersBg, {
                duration: 0.3,
                autoAlpha: 0
            })
            gsap.to(this.filtersWrapper, {
                duration: 0.3,
                height: 0,
                ease: 'power2.inOut',
                onComplete: () => {
                    this.filtersList.style.display = 'none'
                    this.isOpening = false
                    resolve()
                }
            })
            this.filters.classList.remove('opened')

        })
    }

    preventLink() {
        this.filtersLink.addEventListener('click', e => {
            if (this.filtersLinkCta.classList.contains('disabled')) {
                e.preventDefault()
            }
        })
        // this.resetLink.addEventListener('click', e => {
        //     if(this.resetLinkCta.classList.contains('disabled')){
        //         e.preventDefault()
        //     }
        // })
    }
    enableBtnApplyFilter() {
        if (this.filtersLinkCta.classList.contains('disabled')) {
            this.filtersLinkCta.classList.remove('disabled')
        }
    }
    enableBtnResetFilter() {
        if (this.resetLinkCta.classList.contains('disabled')) {
            this.resetLinkCta.classList.remove('disabled')
        }
    }
    disableBtnResetFilter() {
        // if(this.resetLinkCta.classList.contains('disabled')){
        this.resetLinkCta.classList.add('disabled')
        // }
    }
    // checkInitialUrl() {
    //     this.queryString = window.location.search
    //     console.log(this.queryString) //?forma=12&color=130,135
    //     this.urlParams = new URLSearchParams(this.queryString)
    //     console.log(this.urlParams)
    //     this.cat = this.urlParams.get('category') || null
    //     console.log(this.cat)
    //     // this.formaGET = this.urlParams.get('forma') || null
    //     // this.coloreGET = this.urlParams.get('colore') || null
    //     // this.finituraGET = this.urlParams.get('finitura') || null
    // 	// console.log(this.urlParams.getAll('colore'))
    // }
    // isPageSale(){
    //     let pageShop = document.querySelector('.page-shop')
    //     if(pageShop.getAttribute('data-is-sale-page') == 'true'){
    //         return true
    //     }
    //     else{
    //         return false
    //     }
    // }
    // getGenderCategorySaleId(){
    //     return document.querySelector('.page-shop').getAttribute('data-sale-gender-cateogry-id')
    // }
    //Controllo se qualche filtro è attivo
    initFilters() {
        this.activeFiltersCounter.innerHTML = this.totalActiveFilters
        this.filtersElements.forEach((el) => {
            let type = el.getAttribute('data-type')
            // let id = el.getAttribute('data-id')
            if (el.classList.contains('selected')) {
                this.enableBtnResetFilter()
                if (type === 'colore') {
                    this.colori.push(el.getAttribute('data-id'))
                    if (this.colori.length > 0) {
                        this.colorsString = ''
                        this.colori.forEach((itemID, i) => {
                            this.colorsString += itemID.toString()
                            if (this.colori.length !== (i + 1)) {
                                this.colorsString += ','
                            }
                        })
                        this.coloreGET = this.colorsString
                    }
                }
                if (type === 'categoria') {
                    this.categorie.push(el.getAttribute('data-id'))
                    if (this.categorie.length > 0) {
                        this.categorieString = ''
                        this.categorie.forEach((itemID, i) => {
                            this.categorieString += itemID.toString()

                            if (this.categorie.length !== (i + 1)) {
                                this.categorieString += ','
                            }
                        })
                        this.categoriaGET = this.categorieString
                    }
                    else {
                        this.categorieString = ''
                        this.categoriaGET = null
                    }
                }
                if (type === 'taglia') {
                    this.taglie.push(el.getAttribute('data-id'))
                    if (this.taglie.length > 0) {
                        this.taglieString = ''
                        this.taglie.forEach((itemID, i) => {
                            this.taglieString += itemID.toString()

                            if (this.taglie.length !== (i + 1)) {
                                this.taglieString += ','
                            }
                        })
                        this.tagliaGET = this.taglieString
                    }
                    else {
                        this.taglieString = ''
                        this.tagliaGET = null
                    }
                }

            }

        })
    }
    //Controllo i filtri attivi dopo il click su un filtro per attivare/disattivare il reset filter
    checkFilters() {
        this.totalActiveFilters = this.filters.querySelectorAll('.filter__item.selected').length
        this.activeFiltersCounter.innerHTML = this.totalActiveFilters
        if (this.totalActiveFilters > 0) {
            this.enableBtnResetFilter()
        }
        else {
            this.disableBtnResetFilter()
        }
    }
    resetFilters() {
        this.filtersElements.forEach((el) => {
            el.classList.remove('selected')
        })
        let resetUrl = this.cleanUrl
        // if(this.isPageSale()) resetUrl += '?category='+this.getGenderCategorySaleId()
        this.filtersLink.setAttribute('href', resetUrl)
        this.checkFilters()
        this.enableBtnApplyFilter()

    }
    selectFilters() {
        this.filtersElements.forEach((el) => {
            el.addEventListener('click', () => {
                let type = el.getAttribute('data-type')
                let id = el.getAttribute('data-id')
                if (type === 'colore') {
                    if (el.classList.contains('selected')) {
                        const index = this.colori.indexOf(id);
                        if (index > -1) {
                            this.colori.splice(index, 1);
                        }
                        el.classList.remove('selected')
                    }
                    else {
                        this.colori.push(el.getAttribute('data-id'))
                        el.classList.add('selected')
                    }
                    if (this.colori.length > 0) {
                        this.colorsString = ''
                        this.colori.forEach((itemID, i) => {
                            this.colorsString += itemID.toString()

                            if (this.colori.length !== (i + 1)) {
                                this.colorsString += ','
                            }
                        })
                        this.coloreGET = this.colorsString
                    }
                    else {
                        this.colorsString = ''
                        this.coloreGET = null
                    }
                }
                if (type === 'categoria') {
                    if (el.classList.contains('selected')) {
                        const index = this.categorie.indexOf(id);
                        if (index > -1) {
                            this.categorie.splice(index, 1);
                        }
                        el.classList.remove('selected')
                    }
                    else {
                        this.categorie.push(el.getAttribute('data-id'))
                        el.classList.add('selected')
                    }

                    if (this.categorie.length > 0) {
                        this.categorieString = ''
                        this.categorie.forEach((itemID, i) => {
                            this.categorieString += itemID.toString()
                            if (this.categorie.length !== (i + 1)) {
                                this.categorieString += ','
                            }
                        })
                        // if(this.isPageSale()) this.categorieString += ',' + this.getGenderCategorySaleId()
                        this.categoriaGET = this.categorieString
                    }
                    else {
                        this.categorieString = ''
                        // if(this.isPageSale()){
                        //     this.categorieString = this.getGenderCategorySaleId()
                        //     this.categoriaGET = this.categorieString
                        // }
                        // else{
                            this.categoriaGET = null
                        // }
                    }
                }
                if (type === 'taglia') {
                    if (el.classList.contains('selected')) {
                        const index = this.taglie.indexOf(id);
                        if (index > -1) {
                            this.taglie.splice(index, 1);
                        }
                        el.classList.remove('selected')
                    }
                    else {
                        this.taglie.push(el.getAttribute('data-id'))
                        el.classList.add('selected')

                    }
                    if (this.taglie.length > 0) {
                        this.taglieString = ''
                        this.taglie.forEach((itemID, i) => {
                            this.taglieString += itemID.toString()

                            if (this.taglie.length !== (i + 1)) {
                                this.taglieString += ','
                            }
                        })
                        this.tagliaGET = this.taglieString
                    }
                    else {
                        this.taglieString = ''
                        this.tagliaGET = null
                    }

                }
                this.checkFilters()
                this.createLink()
                this.enableBtnApplyFilter()
            })
        })
    }
    createLink() {
        let newLink = ''
        if (this.tagliaGET) {
            newLink += this.cleanUrl + '?size=' + this.tagliaGET
            if (this.categoriaGET) {
                newLink += '&category=' + this.categoriaGET
            }
            if (this.coloreGET) {
                newLink += '&color=' + this.coloreGET
            }
        }
        else if (this.categoriaGET) {
            newLink += this.cleanUrl + '?category=' + this.categoriaGET
            if (this.coloreGET) {
                newLink += '&color=' + this.coloreGET
            }
        }
        else if (this.coloreGET) {
            newLink += this.cleanUrl + '?color=' + this.coloreGET

        }
        else {
            newLink += this.cleanUrl
        }
        this.filtersLink.setAttribute('href', newLink)

    }
}


class InputCoupon {
    constructor(input) {
        this.input = input
        this.inputField = this.input.querySelector('input')
        // console.log()
        this.errorCheckContainer = this.input.closest('.error-check-container')
        this.label = this.input.closest('.form__row').querySelector('.label')
        this.labelError = this.errorCheckContainer.querySelector('.label__error')
        this.labelErrorSpan = this.labelError.querySelector('span')
        this.defaultLabelErrorTxt = this.labelErrorSpan.innerHTML
        this.duration = 0.4
        this.initEvents();

        this.isEmpty = true
    }

    initEvents() {

        let topFocus = '0%'
        if (this.inputField.value !== '') {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
                borderColor: colorSuccess
            });
            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus
            })
        }

        this.inputField.addEventListener('focus', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 3,
            })

            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus
            })
            this.hideMessage()
        })
        this.inputField.addEventListener('blur', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
            })
            if (this.inputField.value == '') {
                gsap.to(this.label, {
                    duration: this.duration,
                    top: '50%'
                })
            }
        })
    }

    resetField() {
        this.inputField.value = ''
        gsap.to(this.label, {
            duration: this.duration,
            top: '50%'
        })
    }


    checkIfIsEmpty() {
        let inputValue = this.inputField.value
        // let errorValue = ''
        //campo txt
        if (inputValue == '') {
            if (this.input.closest('.error-check-container') !== null) {
                this.resetMessage()
            }
            // let error = true
            // this.showMessage(error)
            this.isEmpty = true
        }
        else {
            this.isEmpty = false
            // this.hideMessage()
        }
    }

    resetMessage() {
        this.labelErrorSpan.style.color = colorError
        this.labelErrorSpan.innerHTML = this.defaultLabelErrorTxt
    }

    showMessage(error) {
        if (error) {
            this.labelErrorSpan.style.color = colorError
        }
        else {
            this.labelErrorSpan.style.color = colorSuccess
        }
        gsap.to(this.labelError, {
            duration: 0.2,
            autoAlpha: 1
        })
    }

    setMessage(message) {
        this.labelErrorSpan.innerHTML = message
    }

    hideMessage() {
        return new Promise(resolve => {

            gsap.to(this.labelError, {
                duration: 0.2,
                autoAlpha: 0,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }
}

class CartFunctions {
    constructor(cartPage) {
        this.cartPage = cartPage
        this.couponWrapper = this.cartPage.querySelector('.coupon')
        this.inputCoupon = new InputCoupon(this.couponWrapper.querySelector('.input'))

        this.submitCouponBtn = this.cartPage.querySelector('.submit-coupon')

        this.iconaBagQty = document.querySelector('.js-bag-counter')


        this.subtotal = this.cartPage.querySelector('.bill__subtotal .js-subtotal')
        this.total = this.cartPage.querySelector('.bill__total .js-total')
        this.billCoupons = this.cartPage.querySelector('.bill__coupons')

        this.cartEmpty = this.cartPage.querySelector('.cart--empty')
        this.productList = this.cartPage.querySelector('.products')
        this.recapOrder = this.cartPage.querySelector('.recap-order')

        this.isUploading = false
        this.duration = 0.4
        this.initEvents()
    }

    initEvents() {
        this.initRemoveCouponButtons()
        this.submitCouponBtn.addEventListener('click', () => {
            // console.log(this.isUploading)
            if (this.isUploading) return
            this.isUploading = true
            this.inputCoupon.checkIfIsEmpty()
            if (this.inputCoupon.isEmpty) {
                this.inputCoupon.showMessage(this.inputCoupon.isEmpty)
                this.isUploading = false
            }
            else {
                // console.log(this.inputCoupon.inputField.value)
                this.applyCoupon()
            }
        })

        if (this.cartPage.querySelector('.remove-product-btn') !== null) {
            let removeProductButtons = [...this.cartPage.querySelectorAll('.remove-product-btn')]
            removeProductButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    // if(this.isDeleting) return
                    // this.isDeleting = true
                    this.beforeRemoveProduct()
                    let key = btn.getAttribute('data-key')
                    this.removeProduct(key)
                })
            })
        }

    }

    beforeRemoveProduct() {
        //Hide bag icon, show after update cart quantity
        gsap.to(this.iconaBagQty, {
            duration: 0.4,
            autoAlpha: 0
        })
    }


    applyCoupon() {
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'apply_coupon')
        formData.append('code', this.inputCoupon.inputField.value)
        let url = document.getElementById('uri').value + '/AJAX/cart.php'
        request.open('POST', url, true)
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                // console.log(res)
                //Coupon success
                if (res.response === true) {
                    this.subtotal.innerHTML = res.subtotal
                    this.total.innerHTML = res.total
                    this.billCoupons.innerHTML = res.coupons
                    let successMessage = this.inputCoupon.labelError.getAttribute('data-success-apply')
                    this.inputCoupon.setMessage(successMessage)
                    this.inputCoupon.showMessage(false)
                    this.inputCoupon.resetField()
                    setTimeout(() => {
                        this.inputCoupon.hideMessage().then(() => {
                            this.inputCoupon.resetMessage()
                            this.isUploading = false
                        })
                    }, 2000)
                    //Reinizializzo i bottoni REMOVE altrimenti non vengono rilevati
                    this.initRemoveCouponButtons()

                }
                else if (res.response === 'already-applied') {
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-already-applied')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                else if (res.response === 'minimo-due-prodotti') {
                    // console.log('qui, minimo 2')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-minimo-due-prodotti')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                else if (res.response === 'non-cumulabile') {
                    // console.log('non cumulabile')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-non-cumulabile')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                //Altri motivi (uso singolo, scaduto, non applicabile sui saldi, etc)
                else {
                    // console.log('qui, generico')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-generic')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }

                // this.stopWaiting()
            }
        }
    }

    removeCoupon(code) {

        let formData = new FormData()
        formData.append('action', 'remove_coupon')
        formData.append('code', code)
        let request = new XMLHttpRequest()
        // let url = document.getElementById('uri').value + '/AJAX/cart.php'
        let url = homeUrl + '/opzione-sito/ajax-cart'
        request.open('POST', url, true)
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                console.log(res)
                if (res.response === true) {

                    this.subtotal.innerHTML = res.subtotal
                    this.total.innerHTML = res.total
                    this.billCoupons.innerHTML = res.coupons
                    this.initRemoveCouponButtons()
                    let successMessage = this.inputCoupon.labelError.getAttribute('data-success-remove')
                    this.inputCoupon.setMessage(successMessage)
                    this.inputCoupon.showMessage(false)
                    setTimeout(() => {
                        this.inputCoupon.hideMessage().then(() => {
                            this.inputCoupon.resetMessage()
                            this.isDeleting = false
                        })
                    }, 2000)
                }
                else {
                    console.log('errore')
                    this.isDeleting = false
                }
            }
        }
    }

    initRemoveCouponButtons() {
        if (this.cartPage.querySelector('.remove-coupon-btn') !== null) {
            this.removeCouponBtns = [...document.querySelectorAll('.remove-coupon-btn')]
            this.removeCouponBtns.forEach(removeBtn => {
                removeBtn.addEventListener('click', () => {
                    if (this.isDeleting) return
                    this.isDeleting = true
                    let code = removeBtn.getAttribute('data-coupon-code')
                    this.removeCoupon(code)

                })
            })

        }

    }

    removeProduct(key) {
        let formData = new FormData();
        let request = new XMLHttpRequest();
        formData.append('action', 'remove_from_cart');
        formData.append('key', key);
        // let url = document.getElementById('uri').value + '/AJAX/cart.php';
        let url = homeUrl + '/opzione-sito/ajax-cart'
        request.open('POST', url, true);
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response);
                // console.log(res)
                if (res.response === true) {
                    this.subtotal.innerHTML = res.subtotal
                    this.total.innerHTML = res.total
                    this.billCoupons.innerHTML = res.coupons
                    this.initRemoveCouponButtons()
                    let productToDelete = this.cartPage.querySelector('.product[data-key="' + key + '"]')
                    gsap.to(productToDelete, {
                        duration: 0.3,
                        autoAlpha: 0,
                        onComplete: () => {
                            productToDelete.remove()
                            this.iconaBagQty.innerHTML = res.total_prods
                            gsap.to(this.iconaBagQty, {
                                duration: 0.4,
                                autoAlpha: 1
                            })
                            if (res.total_prods == 0) {
                                gsap.to([this.productList, this.recapOrder], {
                                    duration: 0.4,
                                    autoAlpha: 0,
                                    onComplete: () => {
                                        gsap.to([this.productList, this.recapOrder], {
                                            duration: 0,
                                            display: 'none'
                                        })
                                        gsap.to(this.cartEmpty, {
                                            duration: 0,
                                            display: 'block'
                                        })
                                        gsap.to(this.cartEmpty, {
                                            duration: 0.4,
                                            autoAlpha: 1
                                        })
                                    }
                                })
                            }
                        }
                    })


                }
            }
        }

    }
}

class AccountFunctions {
    constructor() {
        this.filters = document.querySelector('.woocommerce-MyAccount-navigation')
        this.list = document.querySelector('.woocommerce-MyAccount-content')
        this.products = document.getElementById('products')
        this.products2Return = document.getElementById('products-to-return')
        this.privacy = document.querySelector('.return__form .return__form_item.pry label')
        this.orders = document.getElementById('return-order-id')
        this.returnSend = document.getElementById('return-send')

        this.init()
    }

    init() {
        // if(isAllMobileDevices){
        //     this.scrollTrigger()
        // }
        if (this.privacy) {
            this.privacy.addEventListener('click', () => {
                let inp = this.privacy.querySelector('#return-privacy')
                if (inp.checked) {
                    this.privacy.classList.add('checked')
                } else {
                    this.privacy.classList.remove('checked')
                }
            })
        }
        if (this.orders) {
            this.orders.addEventListener('change', () => {
                if (this.orders.value != '') {
                    this.changeOrder(this.orders.value)
                } else {
                    this.products.classList.add('prds-no-margin')
                    this.products.classList.remove('prds')
                }
            })
        }
        if (this.returnSend) {
            this.returnSend.addEventListener('click', () => {
                this.sendReturn()
            })
        }
    }

    changeOrder(id) {
        if (this.products.classList.contains('prds-no-margin')) {
            this.products.classList.remove('prds-no-margin')
            this.products.classList.add('prds')
        }
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'change-order-products')
        formData.append('order', id)
        let url = document.getElementById('uri').value + '/AJAX/returns.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                this.products.innerHTML = res.products
                this.selectProducts()
                awdScroll.update()
            }
        }
        request.send(formData)
    }

    selectProducts() {
        let elements = [...this.products.querySelectorAll('li')]
        elements.forEach((el) => {
            el.addEventListener('click', () => {
                el.classList.toggle('selected')
            })
        })
    }


    sendReturn() {
        let conts = document.querySelectorAll('.return__form_item');
        [...conts].forEach((el) => {
            el.classList.remove('err-1', 'err-2');
        });

        let name = document.getElementById('return-name');
        let surname = document.getElementById('return-surname');
        let mail = document.getElementById('return-mail');
        let tel = document.getElementById('return-telephone');
        let order = document.getElementById('return-order-id');
        let issue = document.getElementById('return-issue');
        let products = document.getElementById('products').querySelectorAll('li.selected');
        let message = document.getElementById('return-message');
        let privacy = document.getElementById('return-privacy');
        let prds = [];

        if (name.value.trim() != '' && surname.value.trim() != '' && mail.value.trim() != '' && validateEmail(mail.value.trim()) && order.value != '' && issue.value != '' && privacy.checked && products.length > 0) {
            [...products].forEach((prd, index) => {
                prds[index] = {
                    "id": prd.dataset.id,
                    "var": prd.dataset.var
                }
            });

            let formData = new FormData();
            let request = new XMLHttpRequest();
            formData.append('action', 'send-return');
            formData.append('lang', getCookie('wp-wpml_current_language'));
            formData.append('name', name.value.trim());
            formData.append('surname', surname.value.trim());
            formData.append('mail', mail.value.trim());
            formData.append('tel', tel.value.trim());
            formData.append('order', order.value.trim());
            formData.append('issue', issue.value.trim());
            formData.append('products', JSON.stringify(prds));
            formData.append('message', message.value.trim());

            let ret_form = document.querySelector('.return__form');
            let ret_success = document.querySelector('.return__success');

            let url = document.getElementById('uri').value + '/AJAX/returns.php';
            request.open('POST', url, true);
            request.onreadystatechange = function () {
                if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    // let res = JSON.parse(request.response);
                    // if (res.return == 200) {
                    gsap.to(ret_form, { duration: 0.5, autoAlpha: 0 });
                    ret_success.style.display = 'block';
                    gsap.to(ret_success, { duration: 0.5, autoAlpha: 1, delay: 0.5 });
                    awdScroll.scrollTo(0, {
                        duration: 500,
                        easeing: [1, 0, 0, 1]
                    })
                    // }
                }
            };
            request.send(formData);

        } else {
            if (name.value.trim() == '') {
                name.closest('.return__form_item').classList.add('err-1');
            }
            if (surname.value.trim() == '') {
                surname.closest('.return__form_item').classList.add('err-1');
            }
            if (mail.value.trim() == '' || !validateEmail(mail.value.trim())) {
                if (mail.value.trim() == '') {
                    mail.closest('.return__form_item').classList.add('err-1');
                } else {
                    mail.closest('.return__form_item').classList.add('err-2');
                }
            }
            if (order.value == '') {
                order.closest('.return__form_item').classList.add('err-1');
            }
            if (issue.value == '') {
                issue.closest('.return__form_item').classList.add('err-1');
            }
            if (!privacy.checked) {
                privacy.closest('label').closest('.return__form_item').classList.add('err-1');
            }
            if (products.length == 0 && order.value != '') {
                document.getElementById('products').classList.add('err-1');
            }
        }
    }

    // scrollTrigger() {
    // 	let scroll = this.list.getBoundingClientRect();
    // 	if(!isMobile){
    // 		if(scroll.y < 100){
    // 			this.filters.classList.add('fixed--bar')
    // 			this.list.classList.add('margin--bar')
    // 		}else{
    // 			this.filters.classList.remove('fixed--bar')
    // 			this.list.classList.remove('margin--bar')
    // 		}
    // 	}else{
    // 		if(scroll.y < 80){
    // 			this.filters.classList.add('fixed--bar')
    // 			this.list.classList.add('margin--bar')
    // 		}else{
    // 			this.filters.classList.remove('fixed--bar')
    // 			this.list.classList.remove('margin--bar')
    // 		}
    // 	}
    // 	document.getElementById('container').addEventListener("scroll", (event) => {
    // 		let scroll = this.list.getBoundingClientRect();
    // 		if(!isMobile){
    // 			if(scroll.y < 100){
    // 				this.filters.classList.add('fixed--bar')
    // 				this.list.classList.add('margin--bar')
    // 			}else{
    // 				this.filters.classList.remove('fixed--bar')
    // 				this.list.classList.remove('margin--bar')
    // 			}
    // 		}else{
    // 			if(scroll.y < 80){
    // 				this.filters.classList.add('fixed--bar')
    // 				this.list.classList.add('margin--bar')
    // 			}else{
    // 				this.filters.classList.remove('fixed--bar')
    // 				this.list.classList.remove('margin--bar')
    // 			}
    // 		}
    // 	});
    // }

}

class CheckoutFunctions {
    constructor() {
        //Metto un if perchè al redirect nella pagina thankyou darebbe errore
        // if(document.querySelector('.coupon') !== null){
        this.couponWrapper = document.querySelector('.coupon')
        this.inputCoupon = new InputCoupon(this.couponWrapper.querySelector('.input'))
        this.submitCouponBtn = document.querySelector('.submit-coupon')
        // }
        this.iconaBagQty = document.querySelector('.js-bag-counter')

        this.ship_different = document.getElementById('ship-to-different-address');
        // this.create_account = document.querySelector('.woocommerce-account-fields .form-row.create-account');
        this.errorPanel = document.querySelector('.checkout--error-panel');
        this.errorPanelError = document.querySelector('.checkout--error-panel .js-error');
        this.billing_country = document.getElementById('billing_country');
        this.pay = document.getElementById('payment');
        this.payment_methods = this.pay.querySelectorAll('.wc_payment_methods li');

        this.isUploading = false

        this.initEvents()

    }

    initEvents() {
        this.checkoutPrivacy()
        this.closeErrorPanel()
        if(!isAllMobileDevices){
            this.fixedErrorPanel()
        }

        //Metto un if perchè al redirect nella pagina thankyou darebbe errore
        // if(document.querySelector('.coupon') !== null){
        this.submitCouponBtn.addEventListener('click', () => {
            if (this.isUploading) return
            this.isUploading = true
            this.inputCoupon.checkIfIsEmpty()
            if (this.inputCoupon.isEmpty) {
                this.inputCoupon.showMessage(this.inputCoupon.isEmpty)
                this.isUploading = false
            }
            else {
                // console.log(this.inputCoupon.inputField.value)
                this.applyCoupon()
            }

        })
        // }
        this.ship_different.addEventListener('click', () => {
            let inp = this.ship_different.querySelector('#ship-to-different-address-checkbox');
            if (inp.checked) {
                this.ship_different.querySelector('label').classList.add('checked');
            } else {
                this.ship_different.querySelector('label').classList.remove('checked');
            }
        });
        // if (this.create_account) {
        //     this.create_account.addEventListener('click', () => {
        //         let inp = this.create_account.querySelector('#createaccount');
        //         if (inp.checked) {
        //             this.create_account.querySelector('label').classList.add('checked');
        //         } else {
        //             this.create_account.querySelector('label').classList.remove('checked');
        //         }
        //     });
        // }



        this.billing_country.addEventListener('change', () => {
            document.dispatchEvent(new Event("update_checkout"));
            document.querySelector('body').dispatchEvent(new Event("update_checkout"));
        });


        jQuery('body').on('updated_checkout', (ev) => {
            this.checkIfSelected();
            this.checkoutPrivacy()
            this.closeErrorPanel()
            this.activateRemove()
        });
        jQuery('body').on('payment_method_selected', (ev) => {
            this.checkIfSelected();
            this.checkoutPrivacy()
            this.closeErrorPanel()
            this.activateRemove()
        });
        jQuery('body').on('checkout_error', (event, error) => {
            this.errorPanelError.innerHTML = error;
            gsap.to(this.errorPanel, { duration: 0.5, x: 0, autoAlpha: 1, ease: 'power2.out' });
            // gsap.to(this.errorPanel, { duration: 0.5, delay: 8, x: '100%', autoAlpha: 0, ease: 'power2.out' });
        });
    }
    activateRemove(){
        if (document.querySelector('.remove-product-btn') !== null) {
            let removeProductButtons = [...document.querySelectorAll('.remove-product-btn')]
            removeProductButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.beforeRemoveProduct()
                    let key = btn.getAttribute('data-key')
                    this.removeProduct(key)
                    // document.dispatchEvent(new Event("update_checkout"));
                    // document.querySelector('body').dispatchEvent(new Event("update_checkout"));
                })
            })
        }
    }
    beforeRemoveProduct() {
        //Hide bag icon, show after update cart quantity
        gsap.to(this.iconaBagQty, {
            duration: 0.4,
            autoAlpha: 0
        })
    }

    removeProduct(key) {
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'remove_from_cart')
        formData.append('key', key)
        let url = document.getElementById('uri').value + '/AJAX/cart.php'
        request.open('POST', url, true)
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                if (res.response === true) {
                    // this.subtotal.innerHTML = res.subtotal
                    // this.total.innerHTML = res.total
                    let productToDelete = document.querySelector('.product[data-key="' + key + '"]')
                    gsap.to(productToDelete, {
                        duration: 0.3,
                        autoAlpha: 0,
                        onComplete: () => {
                            productToDelete.remove()
                            this.iconaBagQty.innerHTML = res.total_prods
                            gsap.to(this.iconaBagQty, {
                                duration: 0.4,
                                autoAlpha: 1
                            })

                            document.dispatchEvent(new Event("update_checkout"))
                            document.querySelector('body').dispatchEvent(new Event("update_checkout"))
                            if (res.total_prods == 0) {
                                //Tutti i prodotti eliminati, ricarico la pagina, che in automatico fa redirect sulla pagina carrello
                                location.reload()
                            }
                        }
                    })


                }
            }
        }

    }
    closeErrorPanel() {
        this.errorPanel.addEventListener('click', () => {
            gsap.to(this.errorPanel, { duration: 0.5, x: '100%', autoAlpha: 0, ease: 'power2.out' });
        })
    }

    //Con Locomotive rendo fixed il pannello degli errori
    fixedErrorPanel() {
        awdScroll.on('scroll', args => {
            gsap.to(this.errorPanel, {
                duration: 0,
                y: args.scroll.y
            })
        })
    }

    applyCoupon() {
        let formData = new FormData()
        let request = new XMLHttpRequest()
        formData.append('action', 'apply_coupon')
        formData.append('code', this.inputCoupon.inputField.value)
        // let url = document.getElementById('uri').value + '/AJAX/cart.php'
        let url = homeUrl + '/opzione-sito/ajax-cart'
        request.open('POST', url, true)
        request.send(formData)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                //Coupon success
                if (res.response === true) {
                    let successMessage = this.inputCoupon.labelError.getAttribute('data-success-apply')
                    this.inputCoupon.setMessage(successMessage)
                    this.inputCoupon.showMessage(false)
                    this.inputCoupon.resetField()
                    setTimeout(() => {
                        this.inputCoupon.hideMessage().then(() => {
                            this.inputCoupon.resetMessage()
                            this.isUploading = false

                            //Aggiorna la pagina di checkout sfruttando l'AJAX di default di woocommerce
                            document.dispatchEvent(new Event("update_checkout"));
                            document.querySelector('body').dispatchEvent(new Event("update_checkout"));
                        })
                    }, 2000)

                }
                else if (res.response === 'already-applied') {
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-already-applied')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                else if (res.response === 'minimo-due-prodotti') {
                    // console.log('qui, minimo 2')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-minimo-due-prodotti')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                else if (res.response === 'non-cumulabile') {
                    // console.log('non cumulabile')
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-non-cumulabile')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }
                //Altri motivi (uso singolo, scaduto, non applicabile sui saldi, etc)
                else {
                    let errorMessage = this.inputCoupon.labelError.getAttribute('data-error-generic')
                    this.inputCoupon.setMessage(errorMessage)
                    this.inputCoupon.showMessage(true)
                    this.isUploading = false
                }

                // this.stopWaiting()
            }
        }
    }

    checkoutPrivacy() {
        let newsletterPrivacyBlock = document.getElementById('privacy_policy_field').querySelector('.privacy-checkbox-checkout');
        let check = document.getElementById('privacy_policy');
        check.addEventListener('change', (ev) => {
            if (ev.currentTarget.checked) {
                newsletterPrivacyBlock.classList.add('checked')
            } else {
                newsletterPrivacyBlock.classList.remove('checked')
            }
        })
    }
    checkIfSelected() {
        let payment_methods = document.querySelectorAll('.wc_payment_methods .wc_payment_method');
        [...payment_methods].forEach((el) => {
            let check = el.querySelector('.input-radio');
            if (check.checked) {
                el.classList.add('checked');
            } else {
                el.classList.remove('checked');
            }
        });
    }
    //Codice Fiscale obbligatorio solo in Italia - Attivare se il codice fiscale è attivato
    // checkCountryChange() {
    //     document.getElementById("billing_country").addEventListener("change", (event) => {
    //         if (event.target.value == "IT") {
    //             //console.log(event.target.value)
    //             document.getElementById('billing_fiscal_code').setAttribute('required', 'required')
    //             document.getElementById('billing_fiscal_code_field').classList.add('validate-required')
    //         } else {
    //             document.getElementById('billing_fiscal_code').setAttribute('required', '')
    //             document.getElementById('billing_fiscal_code_field').classList.remove('validate-required')
    //         }
    //     });
    // }
}

function ajaxListaTaglie(){
    if(document.querySelector('.js-lista-taglie') !== null){
        let jsListaTaglieContainers = document.querySelectorAll('.js-lista-taglie')
        let quantiContainers = jsListaTaglieContainers.length
        // console.log(quantiContainers)
        let date1
        let date2
        let limit = quantiContainers-1
        // let limit = 10
        let iconaBagQty = document.querySelector('.js-bag-counter')
        jsListaTaglieContainers.forEach( (containerTaglie, index) => {
            // console.log(index)
            if(index === 0){
                date1 = new Date()
                console.log(date1)
            }
            if(index > limit) return
            // console.log(containerTaglie)
            let productId = containerTaglie.getAttribute('data-product-id')
            let formData = new FormData()
            let request = new XMLHttpRequest()
            formData.append('productId', productId)
            
            formData.append('action', 'desktop')
            let url = document.getElementById('uri').value + '/AJAX/taglie-per-quick-add-to-cart.php'
            request.open('POST', url, true)
            request.onreadystatechange = () => {
                if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    // console.log(request)
                    let res = JSON.parse(request.response)
                    // console.log(res.html)
                    containerTaglie.insertAdjacentHTML('beforeend', res.html);
                    // if (res.return == '200') {
                        // let promise =  new Promise(resolve => {
                            // setTimeout( () => {
                                // console.log(index)
                                // if(index === limit){
                                    // console.log('tutte le taglie desktop sono state caricate')
                                    date2 = new Date()
                                    console.log(date2)
                                    var difference = date1.getTime() - date2.getTime();
                                    var secondsDifference = Math.floor(difference/1000)
                                    console.log('differenza = '+ secondsDifference + ' second/s ');

                                    
                                    let quickAddToCartBtns = [...containerTaglie.querySelectorAll('.quick-add-to-cart-btn')]
                                    quickAddToCartBtns.forEach(addToCartBtn => {

                                        addToCartBtn.addEventListener('click', () => {
                                            // if (this.isAnimating) return
                                            // this.isAnimating = false
                                            if (addToCartBtn.classList.contains('non-disponibile')) return
                                            let sizeId = addToCartBtn.getAttribute('data-size-id')
                                            let productId = addToCartBtn.getAttribute('data-product-id')
                                            let qty = 1
                                            console.log(sizeId, productId)
                                            gsap.to(iconaBagQty, {
                                                duration: 0.4,
                                                autoAlpha: 0
                                            })
                                            gsap.to(classMinicart.minicart, {
                                                duration: 0,
                                                autoAlpha: 1
                                            })
                                            gsap.to(classMinicart.minicartBg, {
                                                duration: 0.6,
                                                autoAlpha: 1,
                                                delay: 0.3
                                            })
                                            addToCart(productId, sizeId, qty)
                            
                                        })
                                    })

                                // }
                                // resolve()
                            // }, 100 * index)
    
    
    
                        // })
                    // }
                    // else {
                        
                    // }
                }
            }
            request.send(formData)

        })
        // console.log(promises)
        // Promise.all(promises).then( () => {
        //     console.log('tutte le taglie sono state caricate')
        // })

    }
}
function ajaxListaTaglieMobile(){
    if(document.querySelector('.js-lista-taglie-mobile') !== null){
        let jsListaTaglieContainers = document.querySelectorAll('.js-lista-taglie-mobile')
        let quantiContainers = jsListaTaglieContainers.length
        // console.log(quantiContainers)
        jsListaTaglieContainers.forEach( (containerTaglie, index) => {
            // console.log(containerTaglie)
            let productId = containerTaglie.getAttribute('data-product-id')
            console.log(productId)
            let formData = new FormData()
            let request = new XMLHttpRequest()
            formData.append('productId', productId)
            formData.append('action', 'mobile')
            let url = document.getElementById('uri').value + '/AJAX/taglie-per-quick-add-to-cart.php'
            request.open('POST', url, true)
            request.onreadystatechange = () => {
                if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    // console.log(request)
                    let res = JSON.parse(request.response)
                    // console.log(res.html)
                    containerTaglie.insertAdjacentHTML('beforeend', res.html);
                    // if (res.return == '200') {
                        // let promise =  new Promise(resolve => {
                            // setTimeout( () => {
                                // console.log(index)
                                if(index === quantiContainers-1){
                                    console.log('tutte le taglie mobile sono state caricate')

                                }
                                // resolve()
                            // }, 100 * index)
    
    
    
                        // })
                    // }
                    // else {
                        
                    // }
                }
            }
            request.send(formData)

        })
        // console.log(promises)
        // Promise.all(promises).then( () => {
        //     console.log('tutte le taglie sono state caricate')
        // })

    }
}

class QuickAddToCart {
    constructor() {
        // this.looklookPage = document.querySelector('.page-lookbook')
        this.quickAddToCartBtns = [...document.querySelectorAll('.quick-add-to-cart-btn')]
        this.iconaBagQty = document.querySelector('.js-bag-counter')

        this.isAnimating = false
        this.initEvents()
    }

    initEvents() {
        this.quickAddToCartBtns.forEach(addToCartBtn => {
            addToCartBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = false
                if (addToCartBtn.classList.contains('non-disponibile')) return
                let sizeId = addToCartBtn.getAttribute('data-size-id')
                let productId = addToCartBtn.getAttribute('data-product-id')
                let qty = 1
                this.beforeAddToCart()
                addToCart(productId, sizeId, qty)

            })
        })
    }

    beforeAddToCart() {
        gsap.to(this.iconaBagQty, {
            duration: 0.4,
            autoAlpha: 0
        })
        gsap.to(classMinicart.minicart, {
            duration: 0,
            autoAlpha: 1
        })
        gsap.to(classMinicart.minicartBg, {
            duration: 0.6,
            autoAlpha: 1,
            delay: 0.3
        })
    }
}
class SlideshowMobile {
    constructor(slider) {
        this.slider = slider
        this.swiperContainer = this.slider.querySelector('.swiper-container')
        // this.controlPrev = this.slider.querySelector('.prev')
        // this.controlNext = this.slider.querySelector('.next')

        this.initEvents()
    }

    initEvents() {
            let slidesPerView = 1.1
            if(isTablet == 'portrait'){
                slidesPerView = 1.5
            }
            else if(isTablet == 'landscape' || isIpadPro == 'portrait'){
                slidesPerView = 1.7
            }
            // var spaceBetween = winsize.width / 10;
            new Swiper(this.swiperContainer, {
                loop: true,
                slidesPerView: slidesPerView,
                spaceBetween: 10,
                // navigation: {
                //   nextEl: this.controlNext,
                //   prevEl: this.controlPrev,
                // },
                onSlideChangeStart: (e) => {
                    console.log(e)
                }

            });
    }
}
class SlideshowVerticaleMobile {
    constructor() {
        // this.slider = slider
        // this.swiperContainer = this.slider.querySelector('.swiper-v')
        // this.controlPrev = this.slider.querySelector('.prev')
        // this.controlNext = this.slider.querySelector('.next')

        this.initEvents()
    }

    initEvents() {

            // var spaceBetween = winsize.width / 10;
            new Swiper('.swiper-v', {
                // loop: true,
                // slidesPerView: 1.1,
                // spaceBetween: 10,
                direction:"vertical",
                // navigation: {
                //   nextEl: this.controlNext,
                //   prevEl: this.controlPrev,
                // },
                // onSlideChangeStart: (e) => {
                //     console.log(e)
                // }

            });
    }
}

// const MobileFunction = () => {
//     const appHeight = () => {
//         const doc = document.documentElement
//         doc.style.setProperty('--app-height', `${window.innerHeight}px`)
//         if (document.body.classList.contains('page-template-cart')) {
//             if (document.body.classList.contains('page-template-cart')) {
//                 let block = document.querySelector('.cart--total_block');
//                 let h = block.getBoundingClientRect().height
//                 doc.style.setProperty('--padding-bottom-mobile', `${h}px`)
//             }

//         } else {
//             doc.style.setProperty('--padding-bottom-mobile', '0px')
//         }

//     }
//     window.addEventListener('resize', appHeight)
//     appHeight()
// }

class FixedAppHeightInMobile {
    constructor() {

        this.appHeight()
    }

    init() {
        window.addEventListener('resize', () => {
            this.appHeight()
        })

        window.addEventListener('orientationchange', () => {
            // console.log('orientation change, is mobile : ', isMobile)
            // alert(winsize.width)
            this.appHeight()
        })
    }

    appHeight() {
        this.doc = document.documentElement
        this.doc.style.setProperty('--app-height', `${window.innerHeight}px`)
        let containerHeight = document.getElementById('container').getBoundingClientRect().height
        // alert(containerHeight)
        // alert(window.innerHeight)
        //TODO: Check se serve decommentare
        // if(!document.body.classList.contains('page-template-cart')){
        //     doc.style.setProperty('--padding-bottom-mobile','0px')
        // }
        // else{
        //     let block = document.querySelector('.cart--total_block')
        //     let blockHeight = block.getBoundingClientRect().heigt
        //     doc.style.setProperty('--padding-bottom-mobile', `${blockHeight}px`)

        // }
    }
}

function initPagePuntiVendita() {
    // console.log(document.querySelector('.page-punti-vendita'))
    let negozi = [...document.querySelectorAll('.negozio')]
    negozi.forEach(negozio => {
        new Negozio(negozio)
    })

}

function initPageSingleProduct() {
    // console.log(data)
    let infoItems = [...document.querySelectorAll('.info__item')]
    infoItems.forEach(infoItem => {
        new SingleProductInfoList(infoItem)
    })
    // console.log(data)
    new SingleProductZoom()
    new SingleProductNavigation()
    new SingleProductAddToCart()
    if(document.querySelector('.btn-apri-popup-guida-taglie')){
        printPopupGuidaTaglie().then( () => {
            document.querySelectorAll('.btn-chiudi-popup-guida-taglie').forEach(btnChiudi => {
                btnChiudi.addEventListener('click', () => {
                    chiudiPopupGuidaTaglie()
                })
            })
        })
        document.querySelector('.btn-apri-popup-guida-taglie').addEventListener('click', () => {
            apriPopupGuidaTaglie()
        })
    }

    if (!isAllMobileDevices) {
        let stickyElements = [...document.querySelectorAll('.sticky-element')]
        stickyElements.forEach(el => {
            let targetClass = el.getAttribute('data-target-class')
            let target = document.getElementsByClassName(targetClass)[0]
            new StickyElement(el, target)
        })

    }
    else if(isIpadPro === 'landscape'){
        let stickyElements = [...document.querySelectorAll('.sticky-element')]
        stickyElements.forEach(stickyElement => {
            new StickyElementForMobile(stickyElement)
        })
    }
}

function apriPopupGuidaTaglie(){
    let popupGuidaTaglie = document.querySelector('.popup-guida-taglie')
    let popupGuidaTaglieBg = popupGuidaTaglie.querySelector('.popup-guida-taglie__bg span')
    let popupGuidaTaglieWrapper = popupGuidaTaglie.querySelector('.popup-guida-taglie__wrapper')

    gsap.set(popupGuidaTaglie, {
        x: '0%'
    })
    gsap.to(popupGuidaTaglieBg, {
        duration: 0.6,
        opacity: 1,
    })
    gsap.to(popupGuidaTaglieWrapper, {
        duration: 1,
        x: '0%',
        ease: 'power1.inOut'
    })
}

function chiudiPopupGuidaTaglie(){
    let popupGuidaTaglie = document.querySelector('.popup-guida-taglie')
    let popupGuidaTaglieBg = popupGuidaTaglie.querySelector('.popup-guida-taglie__bg span')
    let popupGuidaTaglieWrapper = popupGuidaTaglie.querySelector('.popup-guida-taglie__wrapper')


    gsap.to(popupGuidaTaglieWrapper, {
        duration: 0.5,
        x: '100%',
        ease: 'power1.inOut',
        onComplete: () => {
            gsap.set(popupGuidaTaglie, {
                x: '100%'
            })            
        }        
    })
    gsap.to(popupGuidaTaglieBg, {
        duration: 0.3,
        opacity: 0,
    })
}

function printPopupGuidaTaglie(){
    return new Promise( resolve => {
        let url = `${document.getElementById('uri').value}/AJAX/print-popup-guida-taglie.php`
        let popupGuidaTaglie = document.querySelector('.popup-guida-taglie')
        let gender = document.querySelector('.btn-apri-popup-guida-taglie').getAttribute('data-gender')
        let action = 'print-popup-guida-taglie'
        let formData = new FormData();
        let request = new XMLHttpRequest();
        formData.append('action', action);
        formData.append('gender', gender);
        // formData.append('data', JSON.stringify(data));
    
        request.open('POST', url, true);
        request.onreadystatechange = function () {
            if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let res = JSON.parse(request.response)
                console.log(res)
                popupGuidaTaglie.innerHTML = res.htmlContent
                resolve()
                // if(res.return == 200){
                //     resolve(res);
                // }
            }
        };
        request.send(formData);  

    })  
}

class StickyElementForMobile{
    constructor(stickyElement){
        this.stickyElement = stickyElement
        this.targetClass = this.stickyElement.getAttribute('data-target-class')
        this.triggerElement = document.querySelector('.'+this.targetClass)
        this.limit = this.stickyElement.getBoundingClientRect().bottom
        this.initialStickyTop = this.stickyElement.getBoundingClientRect().top
        this.stickyTopFromParent = this.stickyElement.getBoundingClientRect().top - this.triggerElement.getBoundingClientRect().top
        this.topValueToAdd = this.triggerElement.getBoundingClientRect().top + this.triggerElement.getBoundingClientRect().height - winsize.height
        this.offset = winsize.height - this.stickyElement.getBoundingClientRect().height - this.initialStickyTop

        this.initEvents()
    }

    initEvents(){
        if(this.triggerElement.getBoundingClientRect().height >= this.stickyElement.getBoundingClientRect().height){
            this.checkPosition()
            window.addEventListener('scroll', () => {
                this.checkPosition()
            })

        }
    }

    checkPosition(){
        if(this.triggerElement.getBoundingClientRect().bottom <= this.limit){
            // this.stickyElement.style.position = 'absolute'
            this.setPositionAbsolute()
            this.setTopPositionWhenAbsolute()
        }
        else{
            this.setPositionFixed()
            this.setTopPositionWhenFixed()
        }
    }

    setPositionAbsolute(){
        this.stickyElement.style.position = 'absolute'
    }
    setPositionFixed(){
        this.stickyElement.style.position = 'fixed'
    }
    setTopPositionWhenAbsolute(){
        this.stickyElement.style.top = this.topValueToAdd + this.stickyTopFromParent + this.offset + 'px'
    }
    setTopPositionWhenFixed(){
        this.stickyElement.style.top = this.initialStickyTop + 'px'
    }
}

class DropDownElement{
    constructor(wrapper){
        this.wrapper = wrapper
        this.allDropdownElements = [...document.querySelectorAll('.dropdown-element')]
        this.toggler = this.wrapper.querySelector('.dropdown-toggler')
        this.outerElement = this.wrapper.querySelector('.dropdown__outer-element')
        this.innerElement = this.wrapper.querySelector('.dropdown__inner-element')
        this.targetHeight = this.innerElement.getBoundingClientRect().height
        this.icon = this.wrapper.querySelector('.dropdown-icon')
        this.duration = 0.3
        this.ease = 'Power2.inOut'

        this.initEvents()
    }

    initEvents(){
        this.toggler.addEventListener('click', () => {
            this.targetHeight = this.innerElement.getBoundingClientRect().height
            if(this.wrapper.classList.contains('opened')){
                this.animateIcon('close')
                this.close()
            }
            else{
                this.closeOthersElements()
                this.animateIcon('open')
                this.open()
            }
        })
    }

    animateIcon(action){
        let rotation = 45
        if(action === 'close'){
            rotation = 0
        }
        gsap.to(this.icon, {
            rotation: rotation,
            duration: this.duration,
            ease: this.ease
        })
    }

    open(){
        this.wrapper.classList.add('opened')
        gsap.to(this.outerElement, {
            height: this.targetHeight,
            duration: this.duration,
            ease: this.ease
        })
    }
    close(){
        this.wrapper.classList.remove('opened')
        gsap.to(this.outerElement, {
            height: 0,
            duration: this.duration,
            ease: this.ease
        })
    }
    closeOthersElements(){
        DropdownElements.forEach( dropDownClass => {
            if(dropDownClass.wrapper.classList.contains('opened')){
                dropDownClass.close()
                dropDownClass.animateIcon('close')
            }
        })
    }
}

function initPageRegistrazione() {
    let stickyElements = [...document.querySelectorAll('.sticky-element')]
    stickyElements.forEach(el => {
        let target = null
        if (!el.classList.contains('sticky-element--always-fixed')) {
            let targetClass = el.getAttribute('data-target-class')
            target = document.getElementsByClassName(targetClass)[0]
        }
        // new StickyElement(el, target)
    })
}

function setBodyOverflowHidden(){
    document.body.style.overflow = 'hidden'
}
function setBodyOverflowVisible(){
    document.body.style.overflow = 'visible'
}



function initAllFunctions() {
    //Due funzioni con lo scopo di velocizzare il caricamento del listing andando a caricare in AJAX le taglie per il quick add to cart. Al momento però non risolvono il problema perchè il caricamento è ancora troppo lentoproduct_size e product_misura
    // ajaxListaTaglie()
    // ajaxListaTaglieMobile()
    reloadPageOnOrientationChange()

    new TornaSu(document.querySelector('.torna-su'))

    new CustomDataLayer()

    //In funzione, ma per ora non
    new LazyLoad()
    // new LazyLoad({
    //     callback_enter: el => {
    //         // console.log(el)
    //         // setTimeout( () => {
    //         //     awdScroll.update()
    //         // }, 200)
    //     }
    // })
    // alert(winsize.width)

    if(isMobile || isTablet || isIpadPro === 'portrait'){
        if (document.querySelector('.slider-mobile-swiper') !== null) {
            [...document.querySelectorAll('.slider-mobile-swiper')].forEach(slider => {
                new SlideshowMobile(slider)
            })
        }
    }

    if (isAllMobileDevices) {
        new FixedAppHeightInMobile()
    }

    if(isMobile || isTablet){
        if(document.querySelector('.dropdown-element')){
            DropdownElements =  [...document.querySelectorAll('.dropdown-element')].map( dropdownEl => new DropDownElement(dropdownEl))
        }
    }

    // if(isMobile || isTablet){
        initMenuSimplebar()
    // }


    if (document.querySelector('.apri-lista-taglie-btn') !== null) {
        let btns = [...document.querySelectorAll('.apri-lista-taglie-btn')]
        classBtnListaTaglie = btns.map(btn => new BtnListaTaglie(btn))
        window.addEventListener('click', () => {
            classBtnListaTaglie.forEach(classBtn => {
                if (classBtn.isSomeListOpened) {
                    classBtn.mostraCta()
                    classBtn.chiudiListaTaglie().then(() => classBtn.isAnimating = false)
                    classBtn.btn.classList.remove('opened')
                    classBtn.isSomeListOpened = false

                }
            })
        })
    }

    if (document.querySelector('.mousecursor-trigger-element') !== null) {
        new MouseCursor()
    }

    if (document.querySelector('header') !== null) {
        classHeader = new Header(document.querySelector('header'))
    }


    if (document.querySelector('.minicart') !== null) {
        classMinicart = new Minicart(document.querySelector('.minicart'))
    }

    if (document.querySelector('.search-page') !== null) {
        let form = document.querySelector('.search-page form')
        globalSearchForm = new SearchForm(form);
    }
    if (document.querySelector('.header-login') !== null) {
        new LoginPopup()
    }
    if (document.querySelector('.filters') !== null) {
        classFilters = new Filters(document.querySelector('.filters'))
    }
    if (document.querySelector('.awd-form') !== null) {
        [...document.querySelectorAll('.awd-form')].forEach(form => {
            // console.log({form})
            new Form(form);
        })
    }
    if (document.querySelector('.quick-add-to-cart-btn') !== null) {
        new QuickAddToCart()
    }

    //Pagine
    if (document.querySelectorAll('.page-punti-vendita') !== null) {
        initPagePuntiVendita()
    }
    if (document.querySelector('.page-single-product') !== null) {
        initPageSingleProduct()
    }
    if (document.querySelector('.page-registrazione') !== null) {
        initPageRegistrazione()
    }
    if (document.querySelector('.page-carrello') !== null) {
        new CartFunctions(document.querySelector('.page-carrello'))
        // if(isTablet === 'portrait' || isIpadPro === 'portrait'){
        //     let stickyElements = [...document.querySelectorAll('.sticky-element')]
        //     stickyElements.forEach(stickyElement => {
        //         new StickyElementForMobile(stickyElement)
        //     })
        // }
        //TODO: Se c'è tempo: provare ad attivare lo sticky sul recap order
        // else{
        //     let stickyElements = [...document.querySelectorAll('.sticky-element')]
        //     stickyElements.forEach(el => {
        //         let targetClass = el.getAttribute('data-target-class')
        //         let target = document.getElementsByClassName(targetClass)[0]
        //         new StickyElement(el, target)
        //     })
        // }
    }
    if (document.querySelector('.page-checkout') !== null) {
        if (document.querySelector('.thankyou--page') === null) {
            new CheckoutFunctions()
        }
    }
    if (document.querySelector('.page-account') !== null) {
        new AccountFunctions()
    }
}


var _animations = () => {
    awdScroll.on('call', (value, way, obj) => {
        if(value == 'updateScroll'){
            let el = obj.el;
            if(!el.classList.contains('once')){
                el.classList.add('once')
                awdScroll.update();

            }
        }
        // if(value == 'lazy'){
        //     let el = obj.el;
        //     let sources = [...el.querySelectorAll('source')]
        //     let img = el.querySelector('img')
        //     sources.forEach( src => {
        //         let dataSrc = src.getAttribute('data-srcset')
        //         src.setAttribute('src', dataSrc)
        //     })
        //     img.setAttribute('src', img.getAttribute('data-src'))
        //     // if(!el.classList.contains('once')){
        //     //     el.classList.add('once')
        //     //     awdScroll.update();

        //     // }
        // }
        if(value == 'fade-in'){
            let el = obj.el;
            let image = el.querySelectorAll('.fade-in-el')
            if(!el.classList.contains('once')){
                el.classList.add('once')
                gsap.to(image,{
                    duration:1.2,
                    autoAlpha:1,
                    ease:'power2.in'
                });
                gsap.to(image,{
                    duration:1.2,
                    y:0,
                    ease:'power3.out',
                    // delay:delay
                });

            }
        }

        if(value == 'stagger-up-animation'){
            let el = obj.el;
            // console.log(el)
            let delay = 0;
            if(!el.classList.contains('once')){
                el.classList.add('once')
                el.querySelectorAll('.stagger-up-element').forEach( item => {
                    gsap.to(item,{
                        duration:1.2,
                        y:0,
                        ease:'power2.out',
                        delay:delay
                    });
                    gsap.to(item,{
                        duration:1.2,
                        opacity:1,
                        ease:'power1.in',
                        delay:delay
                    });
                    delay += 0.1;
                })

            }
        }
    })

}


const fadeInElementOnMobile = () => {
    let container = document.querySelector('#container')
    let fadeInElements = [...document.querySelectorAll('.fade-in-el')]
    fadeInElements.forEach( element => {
        let elementOffset = element.getBoundingClientRect().top
        container.addEventListener('scroll', e => {
            if(container.scrollTop + winsize.height > elementOffset && !element.classList.contains('once')){
                element.classList.add('once')
                gsap.to(element,{
                    duration:1.2,
                    autoAlpha:1,
                    ease:'power2.in'
                });
                gsap.to(element,{
                    duration:1.2,
                    y:0,
                    ease:'power3.out',
                });
            }
        })
    })
}


class CustomDataLayer {
    constructor() {
        this.ajaxFile = `${document.getElementById('uri').value}/AJAX/custom_datalayer.php`
        this.data = {}
        this.init()
    }
    init() {
        if(document.body.classList.contains('single-product')){
            this.data.product_id = document.querySelector('.add-to-cart-btn').getAttribute('data-product-id')
            this.ajaxCall('view__item', this.data).then((res) => {
                this.singleProductDataLayer(res)
            })
        }

        window.addEventListener('addToCart', e => {
            this.data.product_id = e.detail.productId
            this.data.size_id = e.detail.sizeId
            // console.log(this.data)
            this.ajaxCall('add__to_cart', this.data).then((res) => {
                this.addToCartDataLayer(res)
            })
        })

        // window.addEventListener('removeFromCart', e => {
        //     this.data.element = e.detail.element
        //     // console.log(this.data)
        //     this.ajaxCall('remove__from_cart', this.data).then((res) => {
        //         this.removeFromCartDataLayer(res)
        //     })
        // })
    }
    singleProductDataLayer(data) {
        window.dataLayer = dataLayer || [];
        //dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: 'EUR',
                value: data.price,
                items: [
                    data.result
                ]
            }
        });
    }
    addToCartDataLayer(data){
        window.dataLayer = dataLayer || [];
        //dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: 'EUR',
                value: data.price,
                items: [
                    data.result
                ]
            }
        });
    }
    // removeFromCartDataLayer(data){
    //     window.dataLayer = dataLayer || [];
    //     //dataLayer.push({ ecommerce: null });
    //     dataLayer.push({
    //         event: "remove_from_cart",
    //         ecommerce: {
    //             currency: 'EUR',
    //             value: data.price,
    //             items: [
    //                 data.result
    //             ]
    //         }
    //     });
    // }
    ajaxCall(action, data) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let request = new XMLHttpRequest();
            formData.append('action', action);
            formData.append('data', JSON.stringify(data));

            request.open('POST', this.ajaxFile, true);
            request.onreadystatechange = function () {
                if(request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                    let res = JSON.parse(request.response);
                    if(res.return == 200){
                        resolve(res);
                    }
                }
            };
            request.send(formData);
        })
    }
}

class CategorieMobile{
    constructor(){
        this.listaCategorie = document.querySelector('.lista-categorie')
        this.listaCategorieWrapper = this.listaCategorie.querySelector('.lista-categorie__wrapper')
        this.listaCategorieContainer = this.listaCategorie.querySelector('.lista-categorie__container')
        this.listaCategorieShadow = this.listaCategorie.querySelector('.lista-categorie__shadow')
        this.listaHeight = this.listaCategorieContainer.getBoundingClientRect().height

        this.iconaPlus = document.querySelector('.filters__categorie-title .plus')
        this.btnsToggleCategorie = document.querySelectorAll('.btn-toggle-categorie')
        this.btnsCloseCategorie = document.querySelectorAll('.btn-close-categorie')

        this.isAnimating = false
        
        this.initEvents()

    }
    initEvents(){
        this.btnsToggleCategorie.forEach( btn => {
            btn.addEventListener('click', () => {
                console.log(this.isAnimating)
                if(this.isAnimating) return
                this.isAnimating = true
                if(this.listaCategorie.classList.contains('opened')){
                    this.closeCategorieMobile()
                }
                else{
                    if(classFilters !== null){
                        if(document.querySelector('.filters').classList.contains('opened')){
                            classFilters.closeFilters().then( () => {
                                this.openCategorieMobile()
                            })
                        }
                        else{
                            this.openCategorieMobile()
                        } 
                    }
                    else{
                        this.openCategorieMobile()
                    }           
                }
            })
        })
        this.btnsCloseCategorie.forEach( btn => {
            btn.addEventListener('click', () => {
                if(this.isAnimating) return
                this.isAnimating = true
                this.closeCategorieMobile().then( () => {
                    this.isAnimating = false
                })
            })
        })
    }
    openCategorieMobile(){
        return new Promise( resolve => {
            this.listaCategorie.style.display = 'block'
            this.listaCategorie.classList.add('opened')
            this.listaHeight = this.listaCategorieContainer.getBoundingClientRect().height
            gsap.to(this.iconaPlus, {
                duration: 0.4,
                rotation: 45
            })
            gsap.to(this.listaCategorieShadow, {
                duration: 0.4,
                autoAlpha: 1
            })
            gsap.to(this.listaCategorieWrapper, {
                duration: 1,
                height: this.listaHeight,
                ease: 'power2.inOut',
                onComplete: () => {
                    this.isAnimating = false
                    resolve()
                }
            })

        })
    }
    closeCategorieMobile(){
        return new Promise( resolve => {
            gsap.to(this.iconaPlus, {
                duration: 0.4,
                rotation: 0
            })
            gsap.to(this.listaCategorieWrapper, {
                duration: 0.4,
                height: 0,
            })
            gsap.to(this.listaCategorieShadow, {
                duration: 0.4,
                delay: 0.2,
                autoAlpha: 0,
                onComplete: () => {
                    this.listaCategorie.style.display = 'none'
                    this.listaCategorie.classList.remove('opened')
                    this.isAnimating = false
                    resolve()
                }
            })
        })
    }
}

if(document.querySelector('.lista-categorie') != null){
    classCategorieMobile = new CategorieMobile()
}


function cookiePopUpAnnuncio(){

    if (document.cookie.indexOf("visited=") >= 0) {
      // L'utente era già entrato almeno una volta negli ultimi 5 minuti.
      console.log('gia visitato')
    }
    else {
        // L'utente è almeno da 5 minuti che non visita il sito
        // var a = new Date(),
        //     b = new Date("2023-11-29"), //ultimo giorno della fiera (anno/mese/giorno)
        //     difference = dateDiffInDays(a, b)

        console.log('prima visita')

        //il popup esiste fino al 22 febbraio 2019
        // if(difference >= 0){
            var expiry = new Date();
            var unMinuto = 60*1000;
            // expiry.setTime(expiry.getTime()+(unMinuto/3)); //30 secondi
            // expiry.setTime(expiry.getTime()+(60*unMinuto)); //un'ora
            expiry.setTime(expiry.getTime()+(60*unMinuto*24)); //un giorno
            // expiry.setTime(expiry.getTime()+(60*unMinuto*96)); //4 giorni

            //Creo il cookie 'visited' e lo setto a 'yes'. Infine ne imposto la scadenza
            document.cookie = "visited=yes; expires=" + expiry.toGMTString();
            setTimeout(function(){
                gsap.to(document.querySelector('.popUp-annuncio'),{
                    duretion:1, 
                    autoAlpha:1
                })
                document.querySelectorAll('.btn-close').forEach(btnClose => {
                    btnClose.addEventListener('click',function(){
                        gsap.to(document.querySelector('.popUp-annuncio'),{
                            duration:1,
                            autoAlpha:0
                        })
                    })        
                })
            },3000)
        // }
    }
}
// a and b are javascript Date objects
function dateDiffInDays(a, b) {
    var _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
      // return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function mostra_jpg_variante_colore(){
    let colori = document.querySelectorAll('.product .colore')
    if(colori.length > 0){  
        // console.log(colori)
        colori.forEach(colore => {
            let product = colore.closest('.product')
            // console.log(product)
            colore.addEventListener('mouseover', () => {
                let product_id = colore.getAttribute('data-product-id')
                let jpg_da_mostrare = product.querySelector(`.jpg-variante-colore[data-product-id="${product_id}"]`)
                // console.log(product_id)
                // console.log(jpg_da_mostrare)
                gsap.set(jpg_da_mostrare, {
                    display: 'block'
                })
            })
            colore.addEventListener('mouseleave', () => {
                let product_id = colore.getAttribute('data-product-id')
                let jpg_da_mostrare = product.querySelector(`.jpg-variante-colore[data-product-id="${product_id}"]`)
                // console.log(product_id)
                // console.log(jpg_da_mostrare)
                gsap.set(jpg_da_mostrare, {
                    display: 'none'
                })
            })
        })
    }
}



document.addEventListener("DOMContentLoaded", function () {

    if(document.querySelector('.page-shop') != null){
        // console.log('page shop')
        mostra_jpg_variante_colore()
    }
    
    if(document.querySelector('.popUp-annuncio') != null){
        cookiePopUpAnnuncio()
    }
    
    if(document.querySelector('.row .iframe-fake-control') !== null && !isAllMobileDevices){
        createYouTubeIFrame()
    }

    if(isMobile){
        fadeInElementOnMobile()
    }

    clickHamburger()

    let btnsCloseSubmenuMobile = document.querySelectorAll('.btn-close-submenu')
    btnsCloseSubmenuMobile.forEach( btnCloseSubmenu => {
        btnCloseSubmenu.addEventListener('click', () => {
            let qualeSubmenu = btnCloseSubmenu.closest('.submenu-mobile').getAttribute('data-submenu-mobile')
            closeSubmenuMobile(qualeSubmenu)
        })
    })
    let btnsOpenSubmenuMobile = document.querySelectorAll('.btn-open-submenu')
    btnsOpenSubmenuMobile.forEach( btnOpenSubmenu => {
        btnOpenSubmenu.addEventListener('click', () => {
            let qualeSubmenu = btnOpenSubmenu.getAttribute('data-submenu-mobile')
            openSubmenuMobile(qualeSubmenu)
        })
    })

    // new MouseCursor()

    // let ua = navigator.userAgent || navigator.vendor || window.opera;
    // let isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
    // if (isInstagram) {
    //     loadDelay = 1000
    // }
    let loadDelay = 100
    if(detectedDevice.isAllMobileDevices){
        loadDelay = 1000
    }
    setTimeout(() => {
        let scrollbarClass = 'awd-scrollbar'
        let direction = 'vertical'
        awdScroll = new LocomotiveScroll({
            el: document.querySelector('#scrollable'),
            smooth: true,
            getSpeed: true,
            getDirection: true,
            direction: direction,
            // smoothMobile: true,
            lerp: 0.1,
            scrollbarClass: scrollbarClass
        })
        animations = _animations()
        // scrollToBottom()

        initAllFunctions()

        if (document.querySelectorAll('.rail').length !== null) {
            var rails = document.querySelectorAll('.rail')
            Array.from(rails).forEach(rail => {
                new Rail(rail)
            })
        }
        // fixedToAbsolute(document.querySelector('.gallery__navigation'),document.querySelector('.gallery__wrapper'))


    }, loadDelay)




})
